import { useState, useEffect, useRef, useCallback, useContext, createContext } from "react";
import { Dialog } from "primereact/dialog";
import { Carousel } from "primereact/carousel";
import FlappyBird from "../GameComponent/GameComponent"
import "primereact/resources/themes/lara-dark-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import dinoImage from "./dino.png";
import wizardImage from "./wizard.png";
import darkKnightImage from "./darkKnight.png";
import shroomyImage from "./shroomy.png";
import witchImage from "./witch.png";
import flashImage from "./flash.png";
import frostieImage from "./frostie.png";
import greenieImage from "./greenie.png";
import hulkyImage from "./hulky.png";
import kittyImage from "./kitty.png";
import marioImage from "./mario.png";
import minnieImage from "./minnie.png";
import spideyImage from "./spidey.png";
import stormyImage from "./stormy.png";
import winnieImage from "./winnie.png";
import crystallaImage from "./crystella.png"
import prismieImage from "./prismie.png"
import goldieImage from "./goldie.png"
import tootyhzWebp from "./toothyz.webp"
import toothyzAnimated from "./toothyzAnimated.webp"
import toothyzPng from "./toothyz.png"

import dinoBgPng from "./dinoWithBg.png"
import marioBgPng from "./marioWithBg.png"
import batBgPng from "./batWithBg.png"
import minnieBgPng from "./minnieWithBg.png"
import frostieBgPng from "./frostieWithBg.png"
import kittyBgPng from "./rainbowCatWithBg.png"
// ── Journey Map ───────────────────────────────────────
import journeyMapImage from "./journeyMap.webp";
//products:
import toothyzProducts from "./toothyzProductsAll.png"
// gif
import playfulGif from "./playful.gif"
import stuffedGif from "./stuffed.gif"
import softGif from "./soft.gif"
import shoppingGif from "./shopping.gif"
//feature
import imgFeature1 from "./imageFeature1.png"
import imgFeature2 from "./imageFeature2.png"
import imgFeature3 from "./imageFeature3.png"
import mainBackground from "./mainBg.png"
import softIconGif from "./softIcon.gif"
import outdoorIconGif from "./outdoorIcon.gif"
import bathIconGif from "./bath.gif"
import paintIconGif from "./paint.gif"
import actionIconGif from "./action.gif"
import puzzleIconGif from "./think.gif"
import toothbrushGif from "./toothbrush.gif"
import toothyzSquad from "./toothyzSquad.png"
import shopBackground from "./shopBg2.png"
import toothyzSquad2 from "./toothyzSquad2.jpg"
import movementGif from "./movement.gif"
import aboutBackground from "./aboutBackground.png"
import toothysSquadAnimation from "./toothyzSquadAnimation.gif"


import { client } from '../../lib/shopify';
import EngulfWrapper from "../EngulfWrapper"

import INTRO_GIF from "./spinningProduct.webp"; 
import package1 from "./package1.gif"
import package2 from "./package2.gif"




//terminal panel images in shop
import rectangleBlue from "./rectangleBlue.png";
import rectangleLandscapeLemon from "./rectangleLandscapeLemon.png";
import rectangleVerticalLightOrange from "./rectangleVerticalLightOrange.png";
import rectangleVerticalPink from "./rectangleVerticalPink.png";
import squareCyan from "./SquareCyan.png";
import squareGreen from "./squareGreen.png";
import squareLightViolet from "./squareLightViolet.png";
import squareYellow from "./squareYellow.png";

/*
  ╔══════════════════════════════════════════════════════╗
  ║   TOOTHYZ™  –  Plush Tooth-Shaped Character Toys     ║
  ║   Light (default) / Dark toggle                      ║
  ╚══════════════════════════════════════════════════════╝
*/

// ── Theme context ─────────────────────────────────────
const ThemeCtx = createContext(null);
const useT = () => useContext(ThemeCtx);

// ── Token generator ───────────────────────────────────
function makeTokens(dark) {
  const cyan      = "#0EA5E9";
  const cyanBright= "#38BDF8";
  const cyanGlow  = "#7DD3FC";
  const gold      = "#F59E0B";
  const goldLight = "#FCD34D";
  const pink      = "#EC4899";

  if (dark) return {
    dark: true,
    bgPage:    "#040D1A",
    bgSection: "#081428",
    bgCard:    "#0C1E3A",
    bgCardHi:  "#132952",
    bgInset:   "#020810",
    textHead:  "#F0F8FF",
    textBody:  "#8BB8D4",
    textDim:   "#4A7A9B",
    cyan, cyanBright, cyanGlow,
    gold, goldLight,
    pink,
    navBg:     "rgba(4,13,26,0.95)",
    navBorder: `${cyanBright}18`,
    border:    `${cyanBright}20`,
    borderHi:  `${cyanBright}40`,
    shadowSm:  "0 4px 20px rgba(0,0,0,0.4)",
    shadowMd:  "0 8px 32px rgba(0,0,0,0.5)",
    shadowLg:  "0 20px 48px rgba(0,0,0,0.6)",
    glowCyan:  `0 0 20px ${cyanBright}25`,
    glowGold:  `0 0 20px ${goldLight}20`,
    heroBg: `radial-gradient(ellipse 80% 60% at 50% -10%, ${cyan}30 0%, transparent 60%),
             radial-gradient(ellipse 40% 40% at 80% 80%, ${cyanBright}14 0%, transparent 50%),
             radial-gradient(ellipse 30% 30% at 20% 60%, ${gold}08 0%, transparent 50%),
             linear-gradient(180deg, #020810 0%, #040D1A 40%, #050F1E 70%, #081428 100%)`,
    sectionAlt: "#040D1A",
    dotGrid: `radial-gradient(circle, ${cyanBright}08 1px, transparent 1px)`,
  };

  return {
    dark: false,
    bgPage:    "#F0F8FF",
    bgSection: "#FFFFFF",
    bgCard:    "#FFFFFF",
    bgCardHi:  "#EFF6FF",
    bgInset:   "#DBEAFE",
    textHead:  "#0C1A33",
    textBody:  "#3D6A8A",
    textDim:   "#7BA7C4",
    cyan, cyanBright, cyanGlow,
    gold, goldLight,
    pink,
    navBg:     "rgba(255,255,255,0.96)",
    navBorder: `${cyan}18`,
    border:    `${cyan}25`,
    borderHi:  `${cyan}55`,
    shadowSm:  "0 2px 12px rgba(14,165,233,0.08)",
    shadowMd:  "0 6px 24px rgba(14,165,233,0.10)",
    shadowLg:  "0 16px 40px rgba(14,165,233,0.14)",
    glowCyan:  `0 0 20px ${cyanBright}20`,
    glowGold:  `0 0 20px ${gold}15`,
    heroBg: `radial-gradient(ellipse 80% 60% at 50% -10%, ${cyanBright}18 0%, transparent 60%),
             radial-gradient(ellipse 40% 40% at 80% 80%, ${cyanGlow}12 0%, transparent 50%),
             linear-gradient(180deg, #EFF6FF 0%, #F8FBFF 50%, #FFFFFF 100%)`,
    sectionAlt: "#F0F9FF",
  };
}

// ── Currency formatter ────────────────────────────────
function formatPrice(amount, currencyCode = "GBP") {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
  }).format(parseFloat(amount));
}

// ── 4-point star SVG ─────────────────────────────────
function Star4({ size=14, fill="#FCD34D", opacity=0.7 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path d="M10 0 L11.5 8.5 L20 10 L11.5 11.5 L10 20 L8.5 11.5 L0 10 L8.5 8.5 Z" fill={fill} opacity={opacity}/>
    </svg>
  );
}

// ── 6-point sparkle SVG ──────────────────────────────
function Star6({ size=12, fill="#7DD3FC", opacity=0.65 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 0 L13.2 9 L22 12 L13.2 15 L12 24 L10.8 15 L2 12 L10.8 9 Z" fill={fill} opacity={opacity}/>
      <path d="M12 5 L12.5 10 L17 12 L12.5 14 L12 19 L11.5 14 L7 12 L11.5 10 Z" fill="white" opacity="0.4"/>
    </svg>
  );
}

// ── Heart SVG ────────────────────────────────────────
function Heart({ size=14, fill="#F9A8D4", opacity=0.6 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 18" fill="none">
      <path d="M10 17 C10 17 1 11 1 5.5 C1 2.9 3.1 1 5.5 1 C7.2 1 8.7 2 10 3.5 C11.3 2 12.8 1 14.5 1 C16.9 1 19 2.9 19 5.5 C19 11 10 17 10 17Z"
        fill={fill} opacity={opacity}/>
    </svg>
  );
}

// ── Background scene ──────────────────────────────────
function Sparkles() {
  const T = useT();

  const toothColors = ["#BAE6FD","#FCD34D","#F9A8D4","#A5F3FC","#BBF7D0","#FDE68A","#E9D5FF","#FECACA"];

  const teeth = [
    {x:4,  y:8,  s:22, d:0,   dur:5.5, r:-20, anim:"tooth-drift-a"},
    {x:90, y:5,  s:30, d:1.2, dur:6.2, r:15,  anim:"tooth-drift-b"},
    {x:2,  y:45, s:18, d:2.4, dur:7,   r:10,  anim:"tooth-drift-a"},
    {x:93, y:38, s:24, d:0.6, dur:5.8, r:-12, anim:"tooth-drift-c"},
    {x:50, y:2,  s:20, d:3.1, dur:6.5, r:25,  anim:"tooth-drift-b"},
    {x:20, y:85, s:26, d:1.7, dur:5.2, r:-8,  anim:"tooth-drift-c"},
    {x:78, y:80, s:22, d:0.3, dur:6.8, r:18,  anim:"tooth-drift-a"},
    {x:38, y:92, s:16, d:2.9, dur:7.3, r:-30, anim:"tooth-drift-b"},
    {x:65, y:12, s:28, d:1.5, dur:5.6, r:5,   anim:"tooth-drift-c"},
    {x:12, y:62, s:20, d:3.8, dur:6.1, r:-15, anim:"tooth-drift-a"},
    {x:84, y:58, s:18, d:0.9, dur:7.8, r:22,  anim:"tooth-drift-b"},
    {x:55, y:75, s:24, d:4.2, dur:5.9, r:-6,  anim:"tooth-drift-c"},
  ];

  const stars4 = [
    {x:8, y:14,s:14,d:0.2,  fill:T.goldLight},
    {x:88,y:9, s:18,d:1.1,  fill:T.cyanGlow},
    {x:45,y:6, s:10,d:2.3,  fill:T.pink},
    {x:75,y:22,s:16,d:0.7,  fill:T.goldLight},
    {x:18,y:32,s:12,d:3.1,  fill:T.cyanBright},
    {x:92,y:52,s:14,d:1.8,  fill:T.pink},
    {x:30,y:78,s:18,d:0.4,  fill:T.goldLight},
    {x:62,y:88,s:12,d:2.6,  fill:T.cyanGlow},
    {x:6, y:72,s:10,d:1.5,  fill:T.pink},
    {x:97,y:72,s:16,d:3.4,  fill:T.goldLight},
    {x:48,y:52,s:8, d:0.9,  fill:T.cyanGlow},
    {x:22,y:18,s:12,d:4.1,  fill:T.goldLight},
  ];

  const stars6 = [
    {x:15,y:20,s:16,d:0.5, fill:T.cyanBright},
    {x:82,y:30,s:12,d:1.9, fill:"#FCD34D"},
    {x:60,y:42,s:10,d:3.2, fill:T.cyanGlow},
    {x:34,y:55,s:14,d:0.8, fill:"#F9A8D4"},
    {x:72,y:65,s:12,d:2.1, fill:T.cyanBright},
    {x:10,y:90,s:10,d:1.3, fill:"#FCD34D"},
    {x:88,y:85,s:16,d:3.7, fill:T.cyanGlow},
    {x:42,y:28,s:8, d:0.3, fill:"#F9A8D4"},
  ];

  const hearts = [
    {x:25,y:10,s:14,d:1.4},
    {x:70,y:7, s:18,d:2.8},
    {x:5, y:55,s:12,d:0.6},
    {x:96,y:62,s:14,d:3.3},
    {x:52,y:96,s:16,d:1.0},
    {x:42,y:68,s:10,d:2.2},
  ];

  const dots = [
    {x:33,y:38,s:6,d:0.4,c:T.cyanGlow},{x:80,y:44,s:5,d:1.6,c:T.goldLight},
    {x:18,y:50,s:7,d:2.7,c:T.pink},    {x:58,y:18,s:5,d:0.2,c:T.cyanBright},
    {x:87,y:17,s:6,d:3.5,c:T.goldLight},{x:7, y:28,s:5,d:1.1,c:T.cyanGlow},
    {x:66,y:96,s:7,d:0.8,c:T.pink},    {x:44,y:84,s:6,d:2.0,c:T.cyanBright},
  ];

  const toothOpacity = T.dark ? 0.18 : 0.12;
  const starOpacity  = T.dark ? 0.75 : 0.50;
  const heartOpacity = T.dark ? 0.50 : 0.35;
  const dotOpacity   = T.dark ? 0.45 : 0.28;

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{zIndex:0}}>
      {[...Array(40)].map((_,i)=>{
        const x = (i * 37 + i * i * 7) % 100;
        const y = (i * 53 + i * 11) % 100;
        const s = (i % 3) + 1;
        const delay = (i * 0.3) % 4;
        return (
          <div key={`star-${i}`} className="absolute rounded-full"
            style={{
              left:`${x}%`, top:`${y}%`,
              width:s, height:s,
              background:"white",
              opacity: 0.15 + (i%5)*0.06,
              animation:`sparkle-twinkle ${2+delay}s ease-in-out infinite`,
              animationDelay:`${delay}s`,
            }}/>
        );
      })}

      {teeth.map((t,i) => (
        <div key={`tooth-${i}`} className={`absolute ${t.anim}`}
          style={{left:`${t.x}%`, top:`${t.y}%`,
            transform:`rotate(${t.r}deg)`,
            animationDelay:`${t.d}s`, animationDuration:`${t.dur}s`,
            opacity: toothOpacity * 2.2,
            filter: i%3===0 ? `drop-shadow(0 0 6px ${toothColors[i % toothColors.length]}cc)` : undefined,
          }}>
          <img src={toothyzPng} alt="" style={{width:t.s, height:t.s, objectFit:"contain", display:"block"}}/>
        </div>
      ))}

      {stars4.map((s,i) => (
        <div key={`s4-${i}`} className="absolute sparkle-twinkle"
          style={{left:`${s.x}%`, top:`${s.y}%`, animationDelay:`${s.d}s`}}>
          <Star4 size={s.s} fill={s.fill} opacity={starOpacity}/>
        </div>
      ))}

      {stars6.map((s,i) => (
        <div key={`s6-${i}`} className="absolute sparkle-spin"
          style={{left:`${s.x}%`, top:`${s.y}%`, animationDelay:`${s.d}s`}}>
          <Star6 size={s.s} fill={s.fill} opacity={starOpacity*0.85}/>
        </div>
      ))}

      {hearts.map((h,i) => (
        <div key={`heart-${i}`} className="absolute heart-beat"
          style={{left:`${h.x}%`, top:`${h.y}%`, animationDelay:`${h.d}s`}}>
          <Heart size={h.s} opacity={heartOpacity}/>
        </div>
      ))}

      {dots.map((d,i) => (
        <div key={`dot-${i}`} className="absolute rounded-full sparkle-pulse"
          style={{left:`${d.x}%`, top:`${d.y}%`, width:d.s, height:d.s,
            background:d.c, animationDelay:`${d.d}s`, opacity:dotOpacity}}/>
      ))}
    </div>
  );
}

// ── Kawaii tooth ──────────────────────────────────────
function KawaiiTooth({ size=80, glow=true, className="" }) {
  const T = useT();
  return (
    <svg width={size} height={size*1.25} viewBox="0 0 80 100"
      fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {glow && <ellipse cx="40" cy="96" rx="20" ry="5" fill={T.cyanBright} opacity="0.2"/>}
      <defs>
        <linearGradient id="tg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%"   stopColor="#FFFFFF"/>
          <stop offset="40%"  stopColor="#F0F8FF"/>
          <stop offset="100%" stopColor="#BAE6FD"/>
        </linearGradient>
      </defs>
      <path d="M13 28 C11 7 26 2 40 2 C54 2 69 7 67 28 C67 44 71 66 68 80 C66 90 58 99 53 99 C48 99 46 90 40 90 C34 90 32 99 27 99 C22 99 14 90 12 80 C9 66 13 44 13 28Z"
        fill="url(#tg)"
        style={glow?{filter:`drop-shadow(0 0 12px rgba(56,189,248,0.4))`}:{}}/>
      <path d="M22 15 C24 8 32 4 40 4 C46 4 52 6 56 11"
        fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="3" strokeLinecap="round"/>
      <path d="M18 25 C19 18 24 12 30 9"
        fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round"/>
      <ellipse cx="30" cy="38" rx="6" ry="7" fill="#1A3A5C"/>
      <ellipse cx="50" cy="38" rx="6" ry="7" fill="#1A3A5C"/>
      <ellipse cx="30" cy="38" rx="5" ry="6" fill={T.cyan}/>
      <ellipse cx="50" cy="38" rx="5" ry="6" fill={T.cyan}/>
      <ellipse cx="30" cy="37" rx="4" ry="5" fill="#0369A1"/>
      <ellipse cx="50" cy="37" rx="4" ry="5" fill="#0369A1"/>
      <ellipse cx="28" cy="35" rx="1.5" ry="1.5" fill="white" opacity="0.9"/>
      <ellipse cx="48" cy="35" rx="1.5" ry="1.5" fill="white" opacity="0.9"/>
      <path d="M32 52 Q40 58 48 52" stroke="#1A3A5C" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <path d="M32 52 Q40 60 48 52" fill="#F9A8D4" opacity="0.6"/>
      <ellipse cx="23" cy="50" rx="5" ry="3" fill="#F9A8D4" opacity="0.5"/>
      <ellipse cx="57" cy="50" rx="5" ry="3" fill="#F9A8D4" opacity="0.5"/>
      <path d="M58 12 L59.2 16 L63 17 L59.2 18 L58 22 L56.8 18 L53 17 L56.8 16 Z"
        fill={T.cyanGlow} opacity="0.9"/>
      <path d="M66 8 L66.8 11 L70 11.5 L66.8 12 L66 15 L65.2 12 L62 11.5 L65.2 11 Z"
        fill="white" opacity="0.8"/>
    </svg>
  );
}

// ── 4-point star ──────────────────────────────────────
function Spark({ size=16, color, className="", style={} }) {
  const T = useT();
  return (
    <svg width={size} height={size} viewBox="0 0 20 20"
      className={className} style={style} xmlns="http://www.w3.org/2000/svg">
      <path d="M10 0 L11.5 8.5 L20 10 L11.5 11.5 L10 20 L8.5 11.5 L0 10 L8.5 8.5 Z"
        fill={color || T.cyanGlow}/>
    </svg>
  );
}

// ── Glow button ───────────────────────────────────────
function GlowBtn({ children, onClick, secondary=false, className="" }) {
  const T = useT();
  return (
    <button onClick={onClick} className={`font-black rounded-2xl transition-all duration-200 hover:scale-105 active:scale-95 btn-jelly ${className}`}
      style={{
        fontFamily:"'Bubblegum Sans',cursive",
        padding:"14px 28px", fontSize:"1rem",
        background: secondary
          ? `rgba(56,189,248,0.12)`
          : `linear-gradient(135deg,${T.cyan},${T.cyanBright})`,
        color: secondary ? T.cyan : "#040D1A",
        border: secondary ? `2px solid ${T.cyanBright}55` : "none",
        boxShadow: secondary
          ? `0 0 14px ${T.cyanBright}20, inset 0 0 14px rgba(56,189,248,0.05)`
          : `0 6px 24px rgba(56,189,248,0.45), 0 2px 8px rgba(56,189,248,0.3), 0 0 40px rgba(56,189,248,0.15)`,
      }}>
      {children}
    </button>
  );
}

// ── Scroll-reveal hook ────────────────────────────────
function useScrollReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px", ...options });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
}

// ── Bouncy per-character animated heading ─────────────
function BounceText({ text, visible, color, fontSize, delay = 0, tag = "h2", className = "" }) {
  const T = useT();
  const words = text.split(" ");
  const Tag = tag;
  let charIndex = 0;

  return (
    <Tag className={className}
      style={{
        fontFamily: "'Bubblegum Sans',cursive",
        fontSize,
        color: color || T.textHead,
        lineHeight: 1.15,
        display: "block",
      }}>
      {words.map((word, wi) => (
        <span key={wi} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
          {word.split("").map((ch, ci) => {
            const idx = charIndex++;
            return (
              <span key={ci}
                style={{
                  display: "inline-block",
                  opacity: visible ? 1 : 0,
                  transform: visible ? "translateY(0) scale(1) rotate(0deg)" : "translateY(32px) scale(0.6) rotate(-8deg)",
                  transition: visible
                    ? `opacity 0.45s cubic-bezier(0.34,1.56,0.64,1) ${delay + idx * 0.038}s,
                       transform 0.52s cubic-bezier(0.34,1.56,0.64,1) ${delay + idx * 0.038}s`
                    : "none",
                }}>
                {ch}
              </span>
            );
          })}
          {wi < words.length - 1 && (
            <span style={{ display: "inline-block" }}>&nbsp;</span>
          )}
        </span>
      ))}
    </Tag>
  );
}

// ── Fade-slide-up for subtitles ───────────────────────
function RevealText({ children, visible, delay = 0, center = true, style = {} }) {
  const T = useT();
  return (
    <div style={{
      opacity: visible ? 1 : 0,
      transform: visible ? "translateY(0)" : "translateY(22px)",
      transition: `opacity 0.6s ease ${delay}s, transform 0.6s cubic-bezier(0.22,1,0.36,1) ${delay}s`,
      textAlign: center ? "center" : "left",
      ...style,
    }}>
      {children}
    </div>
  );
}

// ── Inline scroll-triggered h2 ─────────────────────────
function InlineScrollH2({ text, color, fontSize="clamp(1.8rem,4vw,2.8rem)", center=false }) {
  const T = useT();
  const [ref, visible] = useScrollReveal();
  const words = text.split(" ");
  let charIndex = 0;

  return (
    <h2 ref={ref} style={{
      fontFamily:"'Bubblegum Sans',cursive",
      fontSize,
      lineHeight:1.2,
      marginBottom:16,
      display:"block",
      textAlign: center ? "center" : "left",
    }}>
      {words.map((word, wi) => (
        <span key={wi} style={{display:"inline-block", whiteSpace:"nowrap"}}>
          {word.split("").map((ch, ci) => {
            const idx = charIndex++;
            return (
              <span key={ci} style={{
                display:"inline-block",
                opacity: visible ? 1 : 0,
                transform: visible
                  ? "translateY(0) scale(1) rotate(0deg)"
                  : "translateY(28px) scale(0.65) rotate(-6deg)",
                transition: visible
                  ? `opacity 0.44s cubic-bezier(0.34,1.56,0.64,1) ${idx * 0.04}s,
                     transform 0.50s cubic-bezier(0.34,1.56,0.64,1) ${idx * 0.04}s`
                  : "none",
                color: color || T.textHead,
              }}>
                {ch}
              </span>
            );
          })}
          {wi < words.length - 1 && (
            <span style={{display:"inline-block", minWidth:"0.28em"}}>&nbsp;</span>
          )}
        </span>
      ))}
    </h2>
  );
}

// ── Section heading ───────────────────────────────────
function SectionHead({ eyebrow, title, sub, icon, center = true }) {
  const T = useT();
  const [ref, visible] = useScrollReveal();

  return (
    <div ref={ref} className={`mb-12 ${center ? "text-center" : ""}`}>
      {eyebrow && (
        <RevealText visible={visible} delay={0} center={center}>
          <span
            className="inline-block text-xs font-black tracking-[0.2em] uppercase px-4 py-1.5 rounded-full mb-4"
            style={{
              background: `${T.cyan}15`,
              color: T.cyan,
              border: `1px solid ${T.cyan}33`,
            }}
          >
            {eyebrow}
          </span>
        </RevealText>
      )}

      {/* Container to keep text and icon on the same line */}
      <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
        <BounceText
          text={title}
          visible={visible}
          delay={eyebrow ? 0.08 : 0}
          fontSize="clamp(2rem,5vw,3.2rem)"
          className="mb-3"
        />
        {icon && (
          <div className="mb-3">
             {icon}
          </div>
        )}
      </div>

      {sub && (
        <RevealText visible={visible} delay={0.25 + title.length * 0.018} center={center}>
          <p
            className={`text-base leading-relaxed max-w-lg ${center ? "mx-auto" : ""}`}
            style={{ color: T.textBody }}
          >
            {sub}
          </p>
        </RevealText>
      )}
    </div>
  );
}


function CharCard({ name, theme, desc, color, accent, emoji, tag, delay=0, charimg, webp, lore, onMeet }) {
  const [hov, setHov] = useState(false);
  const imgSrc = charimg || `https://placehold.co/300x220/0C1E3A/38BDF8?text=${encodeURIComponent(name)}`;

  return (
    <div className="char-card-in rounded-[28px] overflow-hidden cursor-pointer relative"
      style={{
        background: "#FFFFFF",
        border: "1.5px solid #E5E7EB",
        animationDelay: `${delay}s`,
        transform: hov ? "translateY(-14px) scale(1.02)" : "translateY(0) scale(1)",
        transition: "transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s ease",
        boxShadow: hov
          ? `0 28px 50px rgba(0,0,0,0.12), 0 0 0 4px ${accent}44`
          : "0 8px 20px rgba(0,0,0,0.06)",
      }}
      onMouseEnter={() => setHov(true)} 
      onMouseLeave={() => setHov(false)}>
      
      <style>{`
        .char-img-box { height: 200px; }
        .vibrant-btn:hover { filter: saturate(1.2) brightness(1.1); box-shadow: 0 8px 20px ${accent}88 !important; }
        @media (max-width: 639px) {
          .char-img-box { height: 140px; }
          .char-card-in { border-radius: 20px !important; }
          .char-card-btn { padding: 10px !important; font-size: 0.75rem !important; }
          .char-card-desc { display: none !important; } /* Hides description on mobile */
          .char-card-body { padding-bottom: 16px !important; }
        }
      `}</style>

      {/* High-Vibrancy Badge */}
      <div className="absolute top-4 left-4 z-10">
        <span className="text-[10px] font-black px-3 py-1 rounded-full shadow-md"
          style={{ 
            background: accent, 
            color: "#000000", 
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            border: "1px solid rgba(0,0,0,0.1)"
          }}>
          {tag}
        </span>
      </div>

      <div className="char-img-wrap mx-4 mt-4 rounded-2xl overflow-hidden relative char-img-box shadow-inner">
        {webp ? (
          <div style={{
            width: "100%", height: "100%",
            backgroundImage: `url(${webp})`,
            backgroundSize: "cover",
            backgroundPosition: "center top",
          }}/>
        ) : (
          <img src={imgSrc} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        )}
      </div>

      <div className="char-card-body px-5 pb-6 pt-4">
        <h3 className="font-black text-2xl mb-0.5"
          style={{ fontFamily: "'Bubblegum Sans',cursive", color: "#000000" }}>
          {name}
        </h3>
        <p className="text-[11px] font-bold mb-2 uppercase tracking-wider" style={{ color: "#444444" }}>
          {theme}
        </p>
        
        {/* Description - Hidden on Mobile via CSS */}
        <p className="char-card-desc text-xs leading-relaxed mb-5" 
          style={{ color: "#555555", fontWeight: "500" }}>
          {desc}
        </p>

        {/* Vibrant Action Button */}
        <button
          onClick={() => onMeet && onMeet()}
          className="vibrant-btn char-card-btn w-full py-3 rounded-2xl font-black text-sm transition-all duration-300 active:scale-95"
          style={{
            background: `linear-gradient(135deg, ${accent} 0%, ${accent} 100%)`,
            color: "#000000",
            boxShadow: `0 6px 18px ${accent}66`,
            fontFamily: "'Bubblegum Sans',cursive",
            border: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px"
          }}>
          <span style={{ fontSize: "1.1rem" }}>{emoji}</span> Meet {name} →
        </button>
      </div>
    </div>
  );
}

function CharDialog({ char, onClose }) {
  const { name, theme, desc, accent, emoji, tag, charimg, lore } = char;

  // 1. Strict Background Scroll Lock
  useEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const header = (
    <div className="flex items-center gap-3 w-full" 
      style={{ fontFamily: "'Bubblegum Sans',cursive", color: "#000000" }}>
      <span className="text-3xl leading-none">{emoji}</span>
      <div className="flex flex-col">
        <div className="text-xl font-black leading-tight text-black">{name}</div>
        <div className="text-[10px] font-black uppercase tracking-widest text-black/40">{theme}</div>
      </div>
      <div className="ml-auto mr-10">
        <span className="text-[10px] font-black px-3 py-1.5 rounded-lg shadow-sm"
          style={{ background: accent, color: "#000000", border: "1px solid rgba(0,0,0,0.05)" }}>
          {tag}
        </span>
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        /* --- DESKTOP: THE COMPACT BOX --- */
        .toothyz-dialog.p-dialog {
          background: #FFFFFF !important;
          border-radius: 32px !important;
          box-shadow: 0 40px 120px -20px rgba(0, 0, 0, 0.45) !important;
          border: none !important;
          overflow: hidden !important;
          
          /* Forced strict dimensions to stop the stretch */
          width: 620px !important; 
          height: 540px !important;
          max-width: 95vw !important;
          animation: dialog-pop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both !important;
        }

        /* --- MOBILE: THE FULL SCREEN --- */
        @media (max-width: 639px) {
          .toothyz-dialog.p-dialog {
            width: 100vw !important;
            height: 100vh !important;
            max-height: 100vh !important;
            margin: 0 !important;
            border-radius: 0 !important;
          }
          .inner-layout { flex-direction: column !important; }
          .side-img-panel { width: 100% !important; height: 35vh !important; border-right: none !important; }
        }

        @keyframes dialog-pop {
          from { opacity: 0; transform: scale(0.95) translateY(30px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }

        /* --- PRIMEREACT OVERRIDES --- */
        .toothyz-dialog .p-dialog-header {
          background: #FFFFFF !important;
          padding: 24px !important;
          border-bottom: 2px solid #F8FAFC !important;
        }

        .toothyz-dialog .p-dialog-header-icons .p-dialog-header-close {
          background: #000000 !important;
          color: #FFFFFF !important;
          border-radius: 12px !important;
          width: 32px !important; height: 32px !important;
          position: absolute !important;
          right: 24px !important;
          transition: all 0.2s ease;
        }
        
        .toothyz-dialog .p-dialog-header-icons .p-dialog-header-close:hover {
          transform: rotate(90deg) scale(1.1);
        }

        .toothyz-dialog .p-dialog-content {
          padding: 0 !important;
          background: #FFFFFF !important;
          height: 100% !important;
        }

        .toothyz-dialog .p-dialog-mask {
          backdrop-filter: blur(12px) !important;
          background: rgba(0, 8, 29, 0.7) !important;
        }

        /* --- INTERNAL LAYOUT --- */
        .inner-layout { display: flex; flex-direction: row; height: 100%; width: 100%; }
        
        .side-img-panel { 
          width: 260px; /* LARGER IMAGE ON DESKTOP */
          background: #F8FAFC; 
          flex-shrink: 0; 
          border-right: 2px solid #F1F5F9;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
          position: relative;
        }

        /* Shadow lift for the plushie */
        .side-img-panel img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          filter: drop-shadow(0 15px 25px rgba(0,0,0,0.12));
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .side-img-panel:hover img {
          transform: scale(1.08);
        }

        .content-panel {
          flex: 1;
          padding: 32px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          background: #FFFFFF;
        }

        .scroll-container { 
          overflow-y: auto; 
          flex: 1; 
          padding-right: 10px; 
        }

        /* Custom Scrollbar */
        .scroll-container::-webkit-scrollbar { width: 5px; }
        .scroll-container::-webkit-scrollbar-thumb { background: #E2E8F0; border-radius: 10px; }

        /* Typography High-Contrast */
        .main-description { 
          color: #000000; 
          font-weight: 800; 
          font-size: 16px; 
          line-height: 1.6; 
          margin-bottom: 24px;
        }
        
        .lore-box {
          background: #F1F5F9;
          border: 1.5px solid #E2E8F0;
          padding: 20px;
          border-radius: 20px;
          margin-bottom: 16px;
        }
      `}</style>

      <Dialog
        visible
        onHide={onClose}
        header={header}
        className="toothyz-dialog"
        modal
        dismissableMask
        blockScroll={true}
      >
        <div className="inner-layout">
          {/* Left Panel: Big Character Image */}
          <div className="side-img-panel">
            <img src={charimg} alt={name} />
          </div>

          {/* Right Panel: Scrollable Info */}
          <div className="content-panel">
            <div className="scroll-container">
              <p className="main-description">
                {desc}
              </p>

              {lore && (
                <div className="lore-box">
                  <p className="text-[10px] font-black uppercase tracking-widest mb-2 text-black/50">
                    ✦ The Backstory
                  </p>
                  <p className="text-[14px] leading-relaxed font-bold italic text-slate-800">
                    {lore}
                  </p>
                </div>
              )}
            </div>

            {/* Action Button */}
            <button 
              onClick={onClose}
              className="w-full py-4 mt-6 rounded-2xl font-black text-sm transition-all active:scale-95 flex items-center justify-center gap-2"
              style={{
                background: accent,
                color: "#000000",
                boxShadow: `0 10px 25px ${accent}66`,
                fontFamily: "'Bubblegum Sans',cursive",
                border: "none",
                cursor: "pointer"
              }}>
              Close {emoji}
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
}

// ── Navbar ────────────────────────────────────────────
function Navbar({ page, setPage }) {
  const T = useT();
  const [scrolled,setScrolled] = useState(false);
  const [open,setOpen] = useState(false);
  useEffect(()=>{
    const fn=()=>setScrolled(window.scrollY>48);
    window.addEventListener("scroll",fn);
    return ()=>window.removeEventListener("scroll",fn);
  },[]);
  const go=(p)=>{setPage(p);setOpen(false);window.scrollTo({top:0,behavior:"instant"});};
  const links=[{label:"Home",p:"home"},{label:"Plushies",p:"characters"},{label:"About",p:"about"},{label:"Shop",p:"shop"},{label:"🎮 Game",p:"game"}];

  const navHidden = !scrolled;

  return (
    <nav className="fixed top-0 inset-x-0 z-50 transition-all duration-500"
      style={{
        background:scrolled?T.navBg:"transparent",
        backdropFilter:scrolled?"blur(24px)":"none",
        borderBottom:scrolled?`1px solid ${T.navBorder}`:"none",
        boxShadow:scrolled?`${T.shadowSm}, 0 0 30px rgba(56,189,248,0.06)`:"none",
        opacity: navHidden ? 0 : 1,
        transform: navHidden ? "translateY(-100%)" : "translateY(0)",
        pointerEvents: navHidden ? "none" : "auto",
      }}>
      <div className="max-w-6xl mx-auto px-5 py-4 flex items-center justify-between">
        <button onClick={()=>go("home")} className="flex items-center gap-2.5">
          <div className="w-20 h-20 rounded-2xl flex items-center justify-center logo-rock">
            <img src={toothyzPng}></img>
          </div>
          <span className="font-black text-2xl"
            style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead,
              textShadow:T.dark?`0 0 20px ${T.cyanBright}66`:"none"}}>
            Toothyz
          </span>
        </button>

        <div className="hidden md:flex items-center gap-1">
          {links.map(l=>(
            <button key={l.p} onClick={()=>go(l.p)}
              className="px-4 py-2 rounded-xl font-bold text-sm transition-all duration-150"
              style={{
                color:page===l.p?T.cyan:T.textBody,
                background:page===l.p?`${T.cyan}15`:"transparent",
                border:page===l.p?`1px solid ${T.cyan}30`:"1px solid transparent",
              }}>
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button onClick={()=>go("shop")}
            className="px-5 py-2.5 rounded-2xl font-black text-sm transition-all hover:scale-105 active:scale-95"
            style={{
              fontFamily:"'Bubblegum Sans',cursive",
              background:`linear-gradient(135deg,${T.cyan},${T.cyanBright})`,
              color:T.dark?"#040D1A":"#FFFFFF",
              boxShadow:`0 4px 16px rgba(56,189,248,0.4)`,
            }}>
            Shop Now ✦
          </button>
        </div>

        <div className="md:hidden flex items-center gap-2">
          <button className="flex flex-col gap-1.5 w-8 h-8 justify-center items-center"
            onClick={()=>setOpen(v=>!v)}>
            {[0,1,2].map(i=>(
              <span key={i} className="block w-5 h-0.5 rounded-full transition-all duration-300"
                style={{
                  background:T.textHead,
                  transform:open?(i===0?"rotate(45deg) translate(3px,3px)":i===2?"rotate(-45deg) translate(3px,-3px)":"none"):"none",
                  opacity:open&&i===1?0:1,
                }}/>
            ))}
          </button>
        </div>
      </div>

      <div className="md:hidden overflow-hidden transition-all duration-300"
        style={{maxHeight:open?"300px":"0",background:T.navBg,borderTop:`1px solid ${T.navBorder}`}}>
        <div className="flex flex-col items-center gap-4 py-5">
          {links.map(l=>(
            <button key={l.p} onClick={()=>go(l.p)} className="font-bold text-base transition-colors"
              style={{color:page===l.p?T.cyan:T.textBody}}>{l.label}</button>
          ))}
          <button onClick={()=>go("shop")} className="px-6 py-2.5 rounded-2xl font-black text-sm"
            style={{background:`linear-gradient(135deg,${T.cyan},${T.cyanBright})`,color:T.dark?"#040D1A":"#FFFFFF"}}>
            Shop Now ✦
          </button>
        </div>
      </div>
    </nav>
  );
}

// ── Footer ────────────────────────────────────────────
function Footer({ setPage }) {
  const T = useT();
  const go=(p)=>{setPage(p);window.scrollTo({top:0,behavior:"instant"});};
  return (
    <footer className="relative z-10 py-14 px-6"
      style={{background:T.dark?T.bgPage:T.sectionAlt, borderTop:`1px solid ${T.navBorder}`}}>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8">
          <button onClick={()=>go("home")} className="flex items-center gap-3">
            <div className="w-24 h-24 rounded-2xl flex items-center justify-center">
              <img src={toothyzPng} size={50} glow={false}/>
            </div>
            <div>
              <p className="font-black text-xl" style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead}}>Toothyz™</p>
              <p className="text-xs" style={{color:T.textBody}}>Tooth-Shaped Plush Collectibles</p>
            </div>
          </button>
          <nav className="flex flex-wrap justify-center gap-6 text-sm font-bold">
            {[["Home","home"],["Plushies","characters"],["About","about"],["Shop","shop"],["🎮 Game","game"]].map(([l,p])=>(
              <button key={p} onClick={()=>go(p)} className="transition-colors"
                style={{color:T.textBody}}
                onMouseEnter={e=>e.currentTarget.style.color=T.cyan}
                onMouseLeave={e=>e.currentTarget.style.color=T.textBody}>{l}</button>
            ))}
          </nav>
          <div className="flex gap-2.5">
            {["𝕏","📷","🎵"].map((ic,i)=>(
              <button key={i} className="w-10 h-10 rounded-xl flex items-center justify-center text-sm transition-all hover:scale-110"
                style={{background:T.bgCard,border:`1px solid ${T.border}`,boxShadow:T.shadowSm}}>
                {ic}
              </button>
            ))}
          </div>
        </div>
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs"
          style={{borderTop:`1px solid ${T.border}`,color:T.textBody}}>
          <p>© {new Date().getFullYear()} Toothyz™. All rights reserved.</p>
          <p><a href="mailto:Contact@toothyz.com" style={{color:T.cyan,textDecoration:"none",fontWeight:"bold"}}>Contact@toothyz.com</a></p>
        </div>
      </div>
    </footer>
  );
}


// ── Journey Section ───────────────────────────────────
function JourneySection({setPage}) {
  const T = useT();
  const [ref, visible] = useScrollReveal();
  const goAbout = () => { setPage('about'); window.scrollTo({ top: 0, behavior: "instant" }); };
  return (
    <section ref={ref} className="py-24 px-5 relative z-10 overflow-hidden" 
      style={{ background: T.dark ? T.bgPage : T.sectionAlt }}>
      <div className="max-w-7xl mx-auto">
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch">
          
          {/* LEFT SIDE: Lore & New Featured Items */}
          <div className="space-y-10">
            {/* Lore Text */}
            <div className="space-y-6">
              <p className="text-sm font-black tracking-widest uppercase"
                style={{ color: T.cyan, letterSpacing: 3 }}>
                📜 Epic Adventure
              </p>
              <h2 className="font-black"
                style={{
                  fontFamily: "'Bubblegum Sans', cursive",
                  fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                  color: T.textHead,
                  lineHeight: 1.1
                }}>
                The Toothyz <span className="about-shimmer">Chronicles</span>
              </h2>
              
              <div className="space-y-4 text-lg" style={{ color: T.textBody }}>
                <p><strong>What Can We Offer?</strong></p>
                <p className="text-base opacity-90">
                  Step into the mystical lands of Dentura. Our heroes traverse through 
                  the Gnasher Peaks and Polished Rivers to protect the Everlasting Shine.
                </p>
                <p className="text-base opacity-90">
                  Our new collection of <strong>Playful, Stuffed, and Soft</strong> companions 
                  are gift-ready and perfect for any explorer. Every Toothyz plush
                  is a reminder of the magic found in every smile!
                </p>
              </div>

              <a className="inline-block px-8 py-4 rounded-2xl font-black text-lg
                transition-all duration-300 hover:scale-105 btn-jelly"
                style={{
                  background: `linear-gradient(135deg, ${T.cyan}, ${T.cyanBright})`,
                  color: T.dark ? '#040D1A' : '#FFFFFF',
                  boxShadow: `0 8px 24px ${T.cyanBright}44`,
                }} onClick={() => goAbout()}>
                Learn About Toothyz 🦷✨
              </a>
            </div>

            {/* NEW IMAGES: Playful, Stuffed, Soft (Left Side) */}
            <div className="grid grid-cols-3 gap-4">
              <div className="space-y-2 text-center">
                <img src={playfulGif} alt="Playful" className="w-full aspect-square object-cover "  />
              </div>
              <div className="space-y-2 text-center">
                <img src={stuffedGif} alt="Stuffed" className="w-full aspect-square object-cover "  />
              </div>
              <div className="space-y-2 text-center">
                <img src={softGif} alt="Soft" className="w-full aspect-square object-cover "  />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE: Journey Map */}
          <div className="flex" style={{ minHeight: "500px" }}>
            <div className="relative overflow-hidden group cursor-zoom-in w-full"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateX(0)' : 'translateX(50px)',
                transition: 'all 1s cubic-bezier(0.34, 1.56, 0.64, 1)'
              }}>
              
              {/* RAW IMAGE with Hover Zoom */}
              <img 
                src={journeyMapImage} 
                alt="Toothyz Chronicles Map" 
                className="w-full h-full block transition-transform duration-700 ease-in-out group-hover:scale-105"
                style={{ objectFit: "cover", display: "block", position: "absolute", inset: 0 }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
function ScrollingBannerBlue() {
  const T = useT();

  return (
    <section
      style={{
        width: "100vw",
        marginLeft: "calc(50% - 50vw)",
        padding: "16px 0",
        background: "linear-gradient(135deg, #0a3a8a 0%, #0d2f6e 50%, #071d4d 100%)",
        position: "relative",
        overflow: "hidden",
        borderTop: "2px solid #a8d4f5",
        borderBottom: "2px solid #a8d4f5",
      }}
    >
      <style>{`
        @keyframes scroll-left-blue {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .scroll-container-blue {
          display: flex;
          animation: scroll-left-blue 22s linear infinite;
          width: fit-content;
        }
        .scroll-container-blue:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="scroll-container-blue">
        {[1, 2].map((set) => (
          <div
            key={set}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "48px",
              paddingRight: "48px",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{
                fontFamily: "'Bubblegum Sans', cursive",
                fontSize: "clamp(1.25rem, 2.5vw, 2rem)",
                fontWeight: 900,
                color: "#fff",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                textShadow: "0 0 18px rgba(56,189,248,0.7), 0 4px 12px rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                gap: "48px",
              }}
            >
              <span>🦷 Super Soft Plush</span>
              <span style={{ fontSize: "1.25rem", color: "#38bdf8" }}>✦</span>
              <span>🎁 Gift-Ready</span>
              <span style={{ fontSize: "1.25rem", color: "#38bdf8" }}>✦</span>
              <span>✨ Limited Collectibles</span>
              <span style={{ fontSize: "1.25rem", color: "#38bdf8" }}>✦</span>
              <span>🦷 10K+ Collectors</span>
              <span style={{ fontSize: "1.25rem", color: "#38bdf8" }}>✦</span>
              <span>🛒 Shop the Collection</span>
              <span style={{ fontSize: "1.25rem", color: "#38bdf8" }}>✦</span>
            </div>
          </div>
        ))}
      </div>

      {/* Gradient fade edges */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "120px",
          height: "100%",
          background: "linear-gradient(to right, #0a3a8a 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "120px",
          height: "100%",
          background: "linear-gradient(to left, #071d4d 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
    </section>
  );
}

function ScrollingBanner() {
  const T = useT();

  return (
    <section
      style={{
        width: "100vw",
        marginLeft: "calc(50% - 50vw)",
        padding: "16px 0",
        background: "linear-gradient(135deg, #f1980b 0%, #d4840a 100%)",
        position: "relative",
        overflow: "hidden",
        borderTop: "2px solid #f9c06a",
        borderBottom: "2px solid #f9c06a",
      }}
    >
      <style>{`
        @keyframes scroll-left {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .scroll-container {
          display: flex;
          animation: scroll-left 20s linear infinite;
          width: fit-content;
        }
        .scroll-container:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="scroll-container">
        {[1, 2].map((set) => (
          <div
            key={set}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "48px",
              paddingRight: "48px",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{
                fontFamily: "'Bubblegum Sans', cursive",
                fontSize: "clamp(1.25rem, 2.5vw, 2rem)",
                fontWeight: 900,
                color: "#fff",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                textShadow: "0 4px 12px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                gap: "48px",
              }}
            >
              <span>🦷 Find the Dentist</span>
              <span style={{ fontSize: "1.25rem", color: "#fde68a" }}>•</span>
              <span>⚔️ Defeat the Cavities</span>
              <span style={{ fontSize: "1.25rem", color: "#fde68a" }}>•</span>
              <span>✨ Protect Your Smile</span>
              <span style={{ fontSize: "1.25rem", color: "#fde68a" }}>•</span>
              <span>🎉 Join the Adventure</span>
              <span style={{ fontSize: "1.25rem", color: "#fde68a" }}>•</span>
            </div>
          </div>
        ))}
      </div>

      {/* Gradient fade edges */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "120px",
          height: "100%",
          background: "linear-gradient(to right, #f1980b 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "120px",
          height: "100%",
          background: "linear-gradient(to left, #d4840a 0%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
    </section>
  );
}
// ── Toothyz Carousel ──────────────────────────────────
function ToothyzGrid({ onMeet, goShop, goChars }) {
  const T = useT();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const characters = [
    {
      name: "Molar-io",
      emoji: "🍄",
      img: marioBgPng,
      bg: "#FFFFFF",
      accent: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
    {
      name: "Batsy",
      emoji: "🦇",
      img: batBgPng,
      bg: "#FFFFFF",
      accent: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
    {
      name: "Frostie",
      emoji: "❄️",
      img: frostieBgPng,
      bg: "#FFFFFF",
      accent: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
    {
      name: "Dino",
      emoji: "🦕",
      img: dinoBgPng,
      bg: "#FFFFFF",
      accent: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
    {
      name: "Minnie",
      emoji: "🔨",
      img: minnieBgPng,
      bg: "#FFFFFF",
      accent: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
    {
      name: "Kitty",
      emoji: "🌈",
      img: kittyBgPng,
      bg: "#FFFFFF",
      accent: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
  ];

  const categories = [
    { icon: softIconGif, label: "Soft Plushies", size: "250%" },
    { icon: outdoorIconGif, label: "Outdoor", size: "200%" },
    { icon: bathIconGif, label: "Bath Time", size: "190%" },
    { icon: paintIconGif, label: "Arts & Crafts", size: "200%" },
    { icon: actionIconGif, label: "Action Figures", size: "200%" },
    { icon: puzzleIconGif, label: "Puzzle & Brain", size: "200%" },
  ];

  return (
    <section
      className="py-16 px-5"
      style={{ background: '#0EA5E9' }}
    >
      <style>{`
        @keyframes float-gentle {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        @keyframes scale-in {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        .picks-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }
        @media (min-width: 640px) {
          .picks-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 24px;
          }
        }
        .category-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          max-width: 700px;
          margin: 0 auto 32px;
        }
        @media (min-width: 640px) {
          .category-grid {
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            gap: 16px;
          }
        }
        .category-circle {
          width: 80px;
          height: 80px;
        }
        @media (min-width: 640px) {
          .category-circle {
            width: 110px;
            height: 110px;
          }
        }
      `}</style>

      <div className="max-w-6xl mx-auto">
        {/* Hero Banner */}
<div
 style={{
 // NEW: An organic, warm off-white gradient
 background: "linear-gradient(180deg, #353945 0%, #353945 100%)",
 borderRadius: "24px",
 padding: "0",
 textAlign: "center",
 marginBottom: "48px",
 position: "relative",
 overflow: "hidden",
 // Preserving your existing shadow
 boxShadow: "0 20px 60px rgba(245, 158, 11, 0.3)",
 }}
>
          {/* Decorative scalloped edge */}
          <div
            style={{
              position: "absolute",
              bottom: -2,
              left: 0,
              right: 0,
              height: "32px",
              background: T.bgSection,
              maskImage: "radial-gradient(circle at 50% 0%, transparent 16px, black 16px)",
              maskSize: "32px 32px",
              maskRepeat: "repeat-x",
              zIndex: 2,
            }}
          />

          {/* Hero Image */}
          <img
            src={toothyzProducts}
            alt="Toothy Characters"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              maxHeight: "500px",
              objectFit: "contain",
              objectPosition: "center",
            }}
          />
        </div>

        {/* Category Icons */}
        <div style={{ marginBottom: "48px" }}>
          <h2
            style={{
              fontFamily: "'Bubblegum Sans', cursive",
              fontSize: "clamp(1rem, 4vw, 1.5rem)",
              color: T.textHead,
              textAlign: "center",
              marginBottom: "24px",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Kid's Favorite Collection
          </h2>

          <div className="category-grid">
            {categories.map((cat, i) => (
              <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>

                {/* The Circle Container */}
                <div
                  className="category-circle"
                  style={{
                    background: "#fff",
                    border: `2px solid ${T.border}`,
                    borderRadius: "50%",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow = "0px 8px 25px rgba(0,0,0,0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "";
                    e.currentTarget.style.boxShadow = "0px 4px 15px rgba(0,0,0,0.2)";
                  }}
                >
                  {/* Icon Layer */}
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundImage: `url(${cat.icon})`,
                      backgroundSize: cat.size,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </div>

                {/* Label */}
                <div
                  style={{
                    fontSize: "clamp(0.6rem, 2vw, 0.75rem)",
                    color: T.textBody || "#fff",
                    textAlign: "center",
                    fontWeight: 800,
                    maxWidth: "110px",
                    lineHeight: 1.2,
                  }}
                >
                  {cat.label}
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              onClick={goChars}
              style={{
                background: T.bgCard,
                border: `2px solid ${T.border}`,
                borderRadius: "24px",
                padding: "8px 24px",
                color: T.textHead,
                fontSize: "0.875rem",
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "";
              }}
            >
              EXPLORE MORE
            </button>
          </div>
        </div>

        {/* Top Playtime Picks Grid */}
        <div>
          <h2
            style={{
              fontFamily: "'Bubblegum Sans', cursive",
              fontSize: "clamp(1.25rem, 5vw, 2rem)",
              color: T.textHead,
              textAlign: "center",
              marginBottom: "32px",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Top Playtime Picks
          </h2>

          <div className="picks-grid">
            {characters.map((char, i) => {
              const isHovered = hoveredIndex === i;

              return (
                <div
                  key={i}
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => {
                    const fullChar = ALL_CHARS.find(ch => ch.name === char.name);
                    if (fullChar && onMeet) onMeet(fullChar);
                  }}
                  style={{
                    background: char.bg,
                    borderRadius: "16px",
                    overflow: "hidden",
                    cursor: "pointer",
                    transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
                    transform: isHovered ? "scale(1.05) translateY(-8px)" : "scale(1)",
                    boxShadow: isHovered
                      ? `0 24px 48px ${char.accent}55, 0 0 0 4px ${char.accent}44`
                      : "0 8px 24px rgba(0,0,0,0.3)",
                    animation: `scale-in 0.5s ease forwards`,
                    animationDelay: `${i * 0.1}s`,
                    opacity: 0,
                  }}
                >
                  {/* Image container */}
                  <div
                    style={{
                      width: "100%",
                      aspectRatio: "1",
                      position: "relative",
                      overflow: "hidden",
                      background: `linear-gradient(180deg, ${char.bg}dd 0%, ${char.bg}99 100%)`,
                    }}
                  >
                    <img
                      src={char.img}
                      alt={char.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "transform 0.4s ease",
                        transform: isHovered ? "scale(1.15)" : "scale(1)",
                      }}
                    />

                    {/* Glow overlay on hover */}
                    {isHovered && (
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: `radial-gradient(circle at 50% 80%, ${char.accent}33 0%, transparent 70%)`,
                          pointerEvents: "none",
                        }}
                      />
                    )}

                    {/* Sparkle on hover */}
                    {isHovered && (
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                        }}
                      >
                        <Spark size={16} color={char.accent} className="spin-slow" />
                      </div>
                    )}
                  </div>

                  {/* Info section */}
                  <div
                    style={{
                      padding: "clamp(8px, 3vw, 20px)",
                      background: "rgba(0,0,0,0.4)",
                      borderTop: `2px solid ${char.accent}44`,
                    }}
                  >
                    <div
                      style={{
                        fontFamily: "'Bubblegum Sans', cursive",
                        fontSize: "clamp(0.875rem, 3.5vw, 1.5rem)",
                        fontWeight: 900,
                        color: "black",
                        marginBottom: "4px",
                        textShadow: `0 2px 8px ${char.accent}`,
                      }}
                    >
                      {char.emoji} {char.name}
                    </div>
                    <div
                      style={{
                        fontSize: "clamp(0.75rem, 3vw, 1.25rem)",
                        fontWeight: 700,
                        color: char.accent,
                        textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                      }}
                    >
                      {char.price}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom CTAs */}
          <div
            style={{
              marginTop: "48px",
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              justifyContent: "center",
            }}
          >

            <button
              onClick={goShop}
              style={{
                background: T.bgCard,
                border: `2px solid ${T.border}`,
                borderRadius: "24px",
                padding: "8px 24px",
                color: T.textHead,
                fontSize: "0.875rem",
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "";
              }}
            >
               View Full Shop →
            </button>
            <button
              onClick={goChars}
              style={{
                background: T.bgCard,
                border: `2px solid ${T.border}`,
                borderRadius: "24px",
                padding: "8px 24px",
                color: T.textHead,
                fontSize: "0.875rem",
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "";
              }}
            >
               See All Characters ✨
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}


// ── Hero title with load-triggered bounce animation ───
// ═══════════════════════════════════════════════════════
//  PAGE, HOME
// ═══════════════════════════════════════════════════════
function HomePage({ setPage, showMascot }) {
  const T = useT();
  const go=(p)=>{setPage(p);window.scrollTo({top:0,behavior:"instant"});};
  const [activeChar, setActiveChar] = useState(null);
  return (
    <div className="relative" style={{zIndex:1}}>
      {activeChar && <CharDialog char={activeChar} onClose={()=>setActiveChar(null)}/>}

      {/* Hero */}
<section 
  className="relative overflow-hidden flex items-center justify-center"
  style={{
    minHeight: "100vh",
    backgroundColor: "#00081d",
    backgroundImage: `url('${mainBackground}')`,
    backgroundSize: "100% auto",
    backgroundPosition: "center calc(100%)",
    backgroundRepeat: "no-repeat"
  }}
>
  <style>{`
    @media (min-width: 1280px) {
      .hero-wide-gradient {
        background: linear-gradient(to bottom, rgba(5, 17, 57, 0.85) 0%, rgba(5, 17, 57, 0.72) 40%, rgba(5, 17, 57, 0.5) 65%, rgba(5, 17, 57, 0.2) 85%, transparent 100%);
      }
    }
  @keyframes toothyz-breathe {
    0%, 100% { 
      /* Use translate3d to force GPU layer */
      transform: translate3d(-50%, -50%, 0) scale(1); 
    }
    50% { 
      transform: translate3d(-50%, -50%, 0) scale(1.15); 
    }
  }
    @keyframes hero-overlay-pulse {
      0%,  42% { opacity: 1; }
      50%, 92% { opacity: 0; }
      100%     { opacity: 1; }
    }

    @media (max-width: 1023px) {
  .animate-mobile-only {
    animation: hero-overlay-pulse 6s ease-in-out infinite;
  }
  .hero-cta-wrap {
    margin-top: 70vw;
  }
  .hero-text-main {
    margin-bottom: 40vw;
  }
}
  `}</style>

  {/* HUGE centered toothyzAnimated — only shown after loading dissolve */}
{showMascot && (
<div 
  className="absolute top-1/2 left-1/2 md:left-[60%] -translate-x-1/2 -translate-y-1/2"
  style={{
    /* 110vw width and 130vw height makes it "burst" out of the mobile frame */
    width: "min(110vw, 1500px)", 
    height: "min(130vw, 1500px)",
    /* Responsive adjustment: reduce size for desktop (md breakpoint) */
    '--desktop-size': 'min(92vw, 1500px)',
    zIndex: 9,
    pointerEvents: "none",
    animation: "toothyz-breathe 5s ease-in-out infinite",
    willChange: "transform",
  }}
>
  <style dangerouslySetInnerHTML={{ __html: `
    @media (min-width: 768px) {
      .mascot-container { 
        width: var(--desktop-size) !important; 
        height: var(--desktop-size) !important; 
      }
    }
    @keyframes mascot-fade-in {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
  `}} />

  <img
    src={toothyzAnimated}
    alt="Toothyz mascot"
    className="mascot-container"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      display: "block",
      filter: "drop-shadow(0 0 80px rgba(0,220,255,0.45)) drop-shadow(0 0 30px rgba(0,220,255,0.2))",
      animation: "mascot-fade-in 1.2s ease-out forwards",
      willChange: "opacity",
    }}
  />
</div>
)}

  <div className="hero-wide-gradient absolute inset-0 pointer-events-none" style={{zIndex: 1}} />

  {/* Edge vignette so mascot feels embedded */}
  <div className="absolute inset-0 pointer-events-none" style={{
    zIndex: 1,
    background: "radial-gradient(ellipse 80% 80% at 50% 50%, transparent 35%, rgba(0,8,29,0.65) 100%)"
  }}/>

  {[
    {top:"8%",  left:"3%",  s:68, delay:0,   rot:-18},
    {top:"18%", right:"4%", s:54, delay:0.7, rot:15 },
    {top:"55%", left:"2%",  s:44, delay:1.3, rot:-8 },
    {top:"65%", right:"3%", s:74, delay:0.4, rot:22 },
    {top:"38%", left:"1%",  s:38, delay:2.0, rot:-28},
  ].map((t, i) => (
    <div key={i} className="absolute pointer-events-none bg-tooth-drift"
      style={{
        top:t.top, left:t.left, right:t.right,
        opacity: T.dark ? 0.35 : 0.28,
        animationDelay: `${t.delay}s`,
        transform: `rotate(${t.rot}deg)`,
        zIndex: 2,
      }}>
      <img src={toothyzPng} alt="" style={{width:t.s, height:t.s, objectFit:"contain", display:"block"}}/>
    </div>
  ))}

  <Spark size={36} color={T.cyanGlow}  className="absolute top-24 left-14 spin-slow"    style={{opacity: T.dark ? 0.8  : 0.5, zIndex:2}}/>
  <Spark size={22} color={T.goldLight} className="absolute top-32 right-24 spin-slow"   style={{opacity: T.dark ? 0.7  : 0.45, animationDirection:"reverse", zIndex:2}}/>
  <Spark size={18} color={T.cyanBright}className="absolute bottom-36 left-28 spin-slow" style={{opacity: T.dark ? 0.6  : 0.4, zIndex:2}}/>
  <Spark size={14} color={T.goldLight} className="absolute bottom-24 right-20 spin-slow"style={{opacity: T.dark ? 0.6  : 0.4, animationDirection:"reverse", zIndex:2}}/>

  {T.dark && (
    <div className="absolute pointer-events-none"
      style={{
        top:"20%", right:"10%", width:320, height:320,
        background: `radial-gradient(circle,${T.cyanBright}12 0%,transparent 70%)`,
        borderRadius:"50%", zIndex:2,
      }}/>
  )}

  {/* Text overlay — pulses in/out every 3 s */}
<div 
  className="hero-text-main relative w-full max-w-4xl px-5 lg:pl-10 text-center lg:text-left mx-auto lg:ml-48"
  style={{ zIndex: 10 }}
>

  {/* Badge pill - Added lg:justify-start */}
  <div className="inline-flex items-center justify-center lg:justify-start gap-2 px-4 py-2 rounded-full mb-6 popup-zoom"
    style={{
      background: `${T.cyan}22`,
      border: `1px solid ${T.cyan}70`,
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)"
    }}>
    <KawaiiTooth size={14} glow={false}/>
    <span className="text-xs font-black tracking-widest uppercase" style={{color: T.cyan}}>
      Plush · Collectible · Iconic
    </span>
    <Spark size={11} color={T.goldLight} className="spin-slow"/>
  </div>

  {/* Headline */}
  <h1 className="font-black leading-none mb-5 fade-up"
    style={{
      fontFamily: "'Bubblegum Sans',cursive",
      fontSize: "clamp(3rem,8vw,5.5rem)",
      animationDelay: "0.1s"
    }}>
    <span style={{
      color: T.textHead,
      textShadow: "0 2px 16px rgba(5,17,57,0.95), 0 1px 4px rgba(0,0,0,0.8)"
    }}>
      Tooth Shaped
    </span><br/>
    <span className="hero-shimmer">
      Plush
    </span><br/>
  </h1>

  {/* Feature badges - Changed justify-center to lg:justify-start */}
  <div className="flex flex-wrap gap-2.5 justify-center lg:justify-start mb-9 popup-slide-up"
    style={{animationDelay: "0.36s"}}>
    {[
      {icon:"🧸", label:"Super Soft Plush"},
      {icon:"🎁", label:"Gift-Ready"},
      {icon:"✨", label:"Collectibles"}
    ].map(f => (
      <span
        key={f.label}
        className="flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-bold rubber-pop"
        style={{
          background: `${T.cyan}33`,
          border: `1.5px solid ${T.cyan}90`,
          color: "#ffffff",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          textShadow: "0 1px 4px rgba(5,17,57,0.8)"
        }}>
        <span>{f.icon}</span>{f.label}
      </span>
    ))}
  </div>

  {/* CTA buttons - Changed justify-center to lg:justify-start */}
  <div className="hero-cta-wrap flex flex-wrap gap-4 justify-center lg:justify-start popup-slide-up"
    style={{animationDelay: "0.48s"}}>
    <GlowBtn onClick={() => go("shop")} className="shop-pulse">Shop the Collection 🛒</GlowBtn>
    <GlowBtn onClick={() => go("game")} className="shop-pulse">Play the game 🎮</GlowBtn>
  </div>
</div>

  {/* Scroll indicator */}
  <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1.5 z-10 popup-slide-up"
    style={{animationDelay: "1.0s"}}>
    <span className="text-xs font-black tracking-widest uppercase" style={{
      color: "#ffffff",
      textShadow: "0 1px 6px rgba(5,17,57,0.9)"
    }}>Scroll</span>
    <div className="w-px h-9 rounded-full scroll-line"/>
  </div>
</section>

      <ScrollingBannerBlue />

      {/* Carousel */}
      <ToothyzGrid
        onMeet={(char) => setActiveChar(char)}
        goShop={() => go("shop")}
        goChars={() => go("characters")}
      />
      <ScrollingBanner />
      {/* Journey Section */}
      <JourneySection setPage={setPage} />

      {/* Testimonials */}
      <section className="py-24 px-5 relative z-10" style={{background:T.dark?T.bgPage:T.sectionAlt}}>
        <div className="max-w-5xl mx-auto">
          <SectionHead 
            eyebrow="Love Letters" 
            title="Collectors Are Obsessed" 
            icon={<img src={toothbrushGif} style={{ width: '150px', height: 'auto' }} alt="toothbrush" />}
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
            {[
              {q:"Got the Wizard one for my daughter, she refused to put it down. The embroidery is stunning!",name:"Sophie T.",ac:T.cyan},
              {q:"The Batman Toothyz is sitting on my desk right now. Quality is unreal for the price. Already ordered more!",name:"James R.",ac:T.goldLight},
              {q:"Bought as a gift, recipient went absolutely feral. Perfect packaging too. Will 100% be back.",name:"Chloe M.",ac:T.pink},
            ].map((t,i)=>(
              <div key={i} className="rounded-3xl p-6 popup-bounce"
                style={{background:T.bgCard,animationDelay:`${i*0.14}s`,
                  border:`1.5px solid ${t.ac}20`,boxShadow:`${T.shadowSm},0 0 20px ${t.ac}08`}}>
                <div className="flex gap-0.5 mb-3">
                  {[...Array(5)].map((_,j)=><span key={j} style={{color:T.goldLight,fontSize:14}}>★</span>)}
                </div>
                <p className="text-sm leading-relaxed italic mb-4" style={{color:T.textBody}}>"{t.q}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full flex items-center justify-center text-base"
                    style={{background:`${t.ac}15`,border:`1px solid ${t.ac}30`}}>😊</div>
                  <p className="font-black text-sm" style={{color:T.textHead}}>{t.name}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-3 gap-5">
            {[{v:"10K+",l:"Happy Collectors",c:T.cyan},{v:"4.9★",l:"Average Rating",c:T.goldLight},{v:"20+",l:"Plushies",c:T.pink}].map((s,i)=>(
              <div key={i} className="rounded-3xl py-8 text-center popup-bounce"
                style={{background:T.bgCard,border:`1.5px solid ${s.c}20`,
                  boxShadow:`${T.shadowSm},0 0 20px ${s.c}08`,animationDelay:`${i*0.12}s`}}>
                <p className="font-black text-4xl mb-1"
                  style={{fontFamily:"'Bubblegum Sans',cursive",color:s.c,
                    textShadow:T.dark?`0 0 16px ${s.c}66`:"none"}}>{s.v}</p>
                <p className="text-xs font-bold" style={{color:T.textBody}}>{s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

{/* CTA */}
<section className="py-24 px-5 relative z-10 min-h-screen flex flex-col" style={{ background: T.bgSection }}>

  <div className="max-w-7xl mx-auto w-full flex flex-col lg:flex-row items-center gap-16">
    
    {/* --- LEFT SIDE: Enhanced Content & Grid --- */}
    <div className="flex-1 space-y-12">
      <h1 className="leading-tight font-bold" style={{ fontFamily:"'Bubblegum Sans',cursive", color: T.textHead, fontSize: "clamp(2.5rem, 4vw, 4rem)" }}>
        Discover the Toothyz Universe <br/>
        <span style={{ color: T.cyanBright }}>More Than Just a Character!</span>
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        
        {/* Feature 1 */}
        <div className="group rounded-[32px] p-8 flex flex-col gap-6 border transition-all hover:shadow-2xl" 
             style={{ background: `${T.bgCard}80`, borderColor: `${T.cyanBright}20` }}>
          <div className="rounded-2xl w-full h-64 overflow-hidden shadow-2xl">
            <img 
              src={imgFeature1} 
              alt="Interactive" 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
            />
          </div>
          <div>
            <h3 className="font-bold text-2xl mb-2" style={{ color: T.textHead }}>Interactive Learning:</h3>
            <p className="text-lg opacity-80" style={{ color: T.textBody }}>Learn fun facts about dental health!</p>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="group rounded-[32px] p-8 flex flex-col gap-6 border transition-all hover:shadow-2xl" 
             style={{ background: `${T.bgCard}80`, borderColor: `${T.cyanBright}20` }}>
          <div className="rounded-2xl w-full h-64 overflow-hidden shadow-2xl">
            <img 
              src={imgFeature2} 
              alt="Quality" 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
            />
          </div>
          <div>
            <h3 className="font-bold text-2xl mb-2" style={{ color: T.textHead }}>Premium Designs:</h3>
            <p className="text-lg opacity-80" style={{ color: T.textBody }}>Each Toothyz is a unique, high-quality creation!</p>
          </div>
        </div>

        {/* Feature 3: Full Width Hero */}
        <div className="group rounded-[32px] p-8 flex flex-col gap-8 border md:col-span-2 transition-all hover:shadow-2xl" 
             style={{ background: `${T.bgCard}80`, borderColor: `${T.cyanBright}20` }}>
          <div className="w-full h-80 overflow-hidden rounded-2xl shadow-2xl">
            <img 
              src={imgFeature3} 
              alt="Community" 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
            />
          </div>
          <div className="text-center md:text-left">
            <h3 className="font-bold text-3xl mb-3" style={{ color: T.textHead }}>Join our Community:</h3>
            <p className="text-xl opacity-80" style={{ color: T.textBody }}>Connect, share, and trade with fellow collectors worldwide!</p>
          </div>
        </div>

      </div>
    </div>

    {/* --- RIGHT SIDE: Sticky Card Container --- */}
    <div className="w-full lg:w-[480px] lg:sticky lg:top-24">
      <div className="rounded-[40px] overflow-hidden relative p-12 text-center"
        style={{
          background: T.dark
            ? `linear-gradient(135deg,${T.bgCard},${T.bgCardHi})`
            : `linear-gradient(135deg,${T.bgCardHi},${T.bgInset})`,
          border: `1.5px solid ${T.cyanBright}40`,
          boxShadow: `0 0 80px ${T.cyanBright}20,${T.shadowLg}`,
        }}>
        
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: `radial-gradient(circle at 50% 0%,${T.cyanBright}15 0%,transparent 60%)` }} />
        
        <Spark size={60} color={`${T.cyanBright}20`} className="absolute -top-4 -left-4 spin-slow" />
        
        <div className="relative z-10">
          {/* Main Card Image also zooms on hover */}
          <div className="relative inline-block mb-8 transition-transform duration-500 hover:scale-110 cursor-pointer">
            <img 
              src={shoppingGif} 
              alt="Toothyz Squad" 
              className="w-full h-auto object-contain transition-transform duration-500"
              style={{ filter: `drop-shadow(0 15px 30px rgba(0,0,0,0.4))` }}
            />
          </div>

          <h2 className="mb-4 font-bold" style={{ color: T.textHead, fontSize: "2.2rem" }}>
            Find Your Perfect Toothyz!
          </h2>
          
          <p className="text-lg mb-10 opacity-90" style={{ color: T.textBody }}>
            Every character is waiting to find a home. Browse the full collection and claim yours today.
          </p>
          
          <GlowBtn onClick={() => go("shop")} className="px-10 py-4 text-lg">Shop Now 🛒</GlowBtn>
        </div>
      </div>
    </div>

  </div>
</section>

      <Footer setPage={setPage}/>
    </div>
  );
}

// ═══════════════════════════════════════════════════════
//  PAGE, CHARACTERS
// ═══════════════════════════════════════════════════════
function PlushiesPage({ setPage }) {
  const T = useT();
  const go=(p)=>{setPage(p);window.scrollTo({top:0,behavior:"instant"});};
  const types=["All","Pop Culture","Fantasy","Gaming","Originals","Accessories", "Limited Edition"];
  const [filter,setFilter]=useState("All");
  const [activeChar, setActiveChar] = useState(null);
  const filtered=filter==="All"?ALL_CHARS:ALL_CHARS.filter(c=>c.cat===filter);
  return (
    <div className="relative z-10" style={{transform:"translateZ(0)",backfaceVisibility:"hidden"}}>
      {activeChar && <CharDialog char={activeChar} onClose={()=>setActiveChar(null)}/>}

      {/* ── Plushies Hero — cinematic centered stage layout ── */}
      <section
        className="relative overflow-hidden flex flex-col"
        style={{
          minHeight: "100vh",
          backgroundColor: "#00081d",
          backgroundImage: `url('${mainBackground}')`,
          backgroundSize: "100% auto",
          backgroundPosition: "center calc(100%)",
          backgroundRepeat: "no-repeat"
        }}
      >
        <style>{`
          .plush-hero-vignette {
            background: linear-gradient(
              to bottom,
              rgba(0,4,20,0.82) 0%,
              rgba(0,4,20,0.55) 35%,
              rgba(0,4,20,0.28) 60%,
              rgba(0,4,20,0.72) 85%,
              rgba(0,4,20,0.96) 100%
            );
          }
          .plush-preview-card {
            transition: transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease;
            cursor: pointer;
          }
          .plush-preview-card:hover {
            transform: translateY(-14px) scale(1.06) !important;
          }
          @keyframes plush-card-rise {
            from { opacity:0; transform: translateY(40px) scale(0.9); }
            to   { opacity:1; transform: translateY(0) scale(1); }
          }
          .plush-card-rise {
            animation: plush-card-rise 0.6s cubic-bezier(0.34,1.56,0.64,1) both;
            will-change: transform, opacity;
          }
          @keyframes plush-title-in {
            from { opacity:0; letter-spacing: 0.3em; }
            to   { opacity:1; letter-spacing: normal; }
          }
          .plush-title-in { animation: plush-title-in 0.9s cubic-bezier(0.22,1,0.36,1) both; will-change: opacity; }
          .plush-divider-line {
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(56,189,248,0.6), rgba(252,211,77,0.5), transparent);
          }
        `}</style>

        {/* Full vignette overlay */}
        <div className="plush-hero-vignette absolute inset-0 pointer-events-none" style={{zIndex:1}}/>

        {/* Ambient glow blobs */}
        <div className="absolute pointer-events-none" style={{top:"15%",left:"10%",width:320,height:320,background:`radial-gradient(circle,${T.cyanBright}10 0%,transparent 70%)`,borderRadius:"50%",zIndex:1}}/>
        <div className="absolute pointer-events-none" style={{top:"20%",right:"8%",width:260,height:260,background:`radial-gradient(circle,${T.goldLight}08 0%,transparent 70%)`,borderRadius:"50%",zIndex:1}}/>
        <Spark size={28} color={T.cyanGlow}  className="absolute spin-slow" style={{top:"18%",left:"7%",opacity:0.65,zIndex:2}}/>
        <Spark size={20} color={T.goldLight} className="absolute spin-slow" style={{top:"22%",right:"9%",opacity:0.6,animationDirection:"reverse",zIndex:2}}/>

        {/* ── TOP AREA: eyebrow + giant title (centered, fills ~60% height) ── */}
        <div className="flex-1 flex flex-col items-center justify-center text-center px-5 relative z-10 pt-32 pb-8">

          {/* Eyebrow tag */}
          <div className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full mb-8 plush-title-in"
            style={{animationDelay:"0s",background:"rgba(56,189,248,0.12)",border:"1px solid rgba(56,189,248,0.45)",backdropFilter:"blur(12px)"}}>
            <KawaiiTooth size={13} glow={false}/>
            <span style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.7rem",fontWeight:900,letterSpacing:"0.2em",color:T.cyanGlow,textTransform:"uppercase"}}>
              The Full Roster
            </span>
            <span style={{width:4,height:4,borderRadius:"50%",background:T.goldLight,display:"inline-block"}}/>
            <span style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.7rem",fontWeight:900,letterSpacing:"0.2em",color:T.goldLight,textTransform:"uppercase"}}>
              20+ Characters
            </span>
          </div>

          {/* Giant title — stacked lines, each its own treatment */}
          <div className="plush-title-in" style={{animationDelay:"0.1s"}}>
            <div style={{
              fontFamily:"'Bubblegum Sans',cursive",
              fontSize:"clamp(1rem,3.5vw,1.4rem)",
              fontWeight:900,
              letterSpacing:"0.35em",
              textTransform:"uppercase",
              color:"rgba(255,255,255,0.55)",
              marginBottom:"0.1em",
              textShadow:"0 1px 8px rgba(0,0,0,0.8)",
            }}>
              Meet the
            </div>
            <h1 style={{
              fontFamily:"'Bubblegum Sans',cursive",
              fontSize:"clamp(4.5rem,11vw,9rem)",
              fontWeight:900,
              lineHeight:0.9,
              margin:0,
            }}>
              <span className="hero-shimmer" style={{
            
                backgroundSize:"200% auto",

                backgroundClip:"text",
                display:"block",
              }}>Toothyz</span>
            </h1>
            <div style={{
              fontFamily:"'Bubblegum Sans',cursive",
              fontSize:"clamp(1.4rem,3.8vw,2.6rem)",
              fontWeight:900,
              color:T.cyan,
              letterSpacing:"0.08em",
              textShadow:`0 0 24px ${T.cyanBright}99, 0 2px 12px rgba(0,0,0,0.8)`,
              marginTop:"0.15em",
            }}>
              Universe 🦷✨
            </div>
          </div>

          {/* Thin divider line */}
          <div className="plush-divider-line w-64 my-6 plush-title-in" style={{animationDelay:"0.3s"}}/>

          {/* One-liner description */}
          <p className="plush-title-in max-w-lg" style={{
            animationDelay:"0.35s",
            fontFamily:"'Nunito',sans-serif",
            fontSize:"clamp(0.95rem,2vw,1.15rem)",
            color:"rgba(255,255,255,0.75)",
            lineHeight:1.65,
            textShadow:"0 1px 8px rgba(0,0,0,0.8)",
          }}>
            From fan-favourite icons to rare limited drops — every character has a name, a story, and a home waiting for it.
          </p>

          {/* Two CTAs */}
          <div className="flex flex-wrap gap-4 justify-center mt-8 plush-title-in" style={{animationDelay:"0.45s"}}>
            <GlowBtn onClick={()=>go("shop")}>Shop the Collection 🛒</GlowBtn>
            <GlowBtn onClick={()=>document.getElementById("plushies-grid")?.scrollIntoView({behavior:"smooth"})} secondary>Browse All ✨</GlowBtn>
          </div>
        </div>

        {/* ── BOTTOM: horizontal preview strip of character cards ── */}
        <div className="relative z-10 pb-10 px-4">
          {/* Fade masks on left/right */}
          <div className="absolute left-0 top-0 bottom-0 w-16 pointer-events-none" style={{background:"linear-gradient(to right,rgba(0,4,20,0.9),transparent)",zIndex:3}}/>
          <div className="absolute right-0 top-0 bottom-0 w-16 pointer-events-none" style={{background:"linear-gradient(to left,rgba(0,4,20,0.9),transparent)",zIndex:3}}/>

          <div className="flex gap-4 justify-center flex-wrap px-8 pt-8">
            {[
              {img:wizardImage,  name:"Wizzy",  emoji:"🧙", color:T.goldLight},
              {img:darkKnightImage, name:"Batsy", emoji:"🦇", color:"#94A3B8"},
              {img:shroomyImage, name:"Shroomy",emoji:"🍄", color:"#F87171"},
              {img:spideyImage,  name:"Spidey", emoji:"🕷️", color:T.cyanBright},
              {img:witchImage,   name:"Hexie",  emoji:"🔮", color:T.pink},
              {img:dinoImage,    name:"Dino",   emoji:"🦕", color:"#86EFAC"},
            ].map((c,i)=>(
              <div key={i} className="plush-preview-card plush-card-rise flex flex-col items-center gap-2"
                style={{animationDelay:`${0.5+i*0.08}s`}}
                onClick={()=>document.getElementById("plushies-grid")?.scrollIntoView({behavior:"smooth"})}>
                <div className="rounded-2xl overflow-hidden relative"
                  style={{
                    width:72,height:86,
                    background:`linear-gradient(145deg,${c.color}22,${c.color}08)`,
                    border:`1.5px solid ${c.color}55`,
                    boxShadow:`0 8px 24px rgba(0,0,0,0.5), 0 0 12px ${c.color}20`,
                  }}>
                  <img src={c.img} alt={c.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                  <div className="absolute bottom-1 right-1 text-xs">{c.emoji}</div>
                </div>
                <span style={{fontFamily:"'Bubblegum Sans',cursive",fontSize:"0.7rem",color:"rgba(255,255,255,0.7)",fontWeight:900}}>{c.name}</span>
              </div>
            ))}
            {/* "and more" pill */}
            <div className="plush-card-rise flex flex-col items-center gap-2" style={{animationDelay:"1.0s"}}>
              <div className="rounded-2xl flex items-center justify-center"
                style={{width:72,height:86,background:`${T.cyan}15`,border:`1.5px dashed ${T.cyan}50`,
                  boxShadow:`0 8px 24px rgba(0,0,0,0.4)`}}>
                <div className="text-center">
                  <div style={{fontFamily:"'Bubblegum Sans',cursive",fontSize:"1.3rem",color:T.cyan}}>14+</div>
                  <div style={{fontSize:"0.6rem",color:T.textBody,fontWeight:800}}>MORE</div>
                </div>
              </div>
              <span style={{fontFamily:"'Bubblegum Sans',cursive",fontSize:"0.7rem",color:"rgba(255,255,255,0.7)",fontWeight:900}}>& more</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Character Grid ── */}
      <section id="plushies-grid" style={{background:T.dark?T.bgPage:T.sectionAlt,paddingTop:80,paddingBottom:80}}>
        <div className="max-w-6xl mx-auto px-5">
          <SectionHead eyebrow="The Full Roster" title="All Toothy Plushies"
            sub="Every character has a name, a backstory, and a design. Who's joining your collection?"/>
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {types.map(t=>(
              <button key={t} onClick={()=>setFilter(t)}
                className="px-5 py-2 rounded-xl font-bold text-sm transition-all duration-200 hover:scale-105"
                style={{
                  background:filter===t?`linear-gradient(135deg,${T.cyan},${T.cyanBright})`:`${T.cyan}10`,
                  color:filter===t?T.dark?"#040D1A":"#FFFFFF":T.textBody,
                  border:filter===t?"none":`1px solid ${T.cyan}20`,
                  boxShadow:filter===t?`0 4px 14px ${T.cyanBright}44`:"none",
                }}>
                {t}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {filtered.map((c,i)=><CharCard key={c.name} {...c} delay={i*0.07} onMeet={()=>setActiveChar(c)}/>)}
          </div>
        </div>
      </section>
      <Footer setPage={setPage}/>
    </div>
  );
}

// ── About page hero title ─────────────────────────────
function AboutHeroTitle() {
  const T = useT();
  const [ref, visible] = useScrollReveal();

  const charStyle = (idx, extraDelay=0) => ({
    display:"inline-block",
    opacity: visible ? 1 : 0,
    transform: visible
      ? "translateY(0) scale(1) rotate(0deg)"
      : "translateY(40px) scale(0.5) rotate(-10deg)",
    transition: visible
      ? `opacity 0.5s cubic-bezier(0.34,1.56,0.64,1) ${extraDelay + idx * 0.038}s,
         transform 0.55s cubic-bezier(0.34,1.56,0.64,1) ${extraDelay + idx * 0.038}s`
      : "none",
    color: T.textHead,
  });

  const line1 = "Join the";
  const shimmer = "Toothyz";
  const line3 = "Movement";

  let gIdx = 0;

  return (
    <h1 ref={ref} style={{
      fontFamily:"'Bubblegum Sans',cursive",
      fontSize:"clamp(3rem,7vw,5.5rem)",
      lineHeight:1.1, marginBottom:24,
      textAlign:"center",
    }}>
      <span style={{display:"block"}}>
        {line1.split("").map((ch) => {
          const idx = gIdx++;
          return (
            <span key={idx} style={{...charStyle(idx), minWidth: ch===" " ? "0.3em" : undefined}}>
              {ch}
            </span>
          );
        })}
      </span>

      <span style={{display:"block"}}>
        {shimmer.split("").map((ch) => {
          const idx = gIdx++;
          return (
            <span key={`s${idx}`} style={{
              display:"inline-block",
              opacity: visible ? 1 : 0,
              transform: visible
                ? "translateY(0) scale(1) rotate(0deg)"
                : "translateY(40px) scale(0.5) rotate(-10deg)",
              transition: visible
                ? `opacity 0.5s cubic-bezier(0.34,1.56,0.64,1) ${idx * 0.038}s,
                   transform 0.55s cubic-bezier(0.34,1.56,0.64,1) ${idx * 0.038}s`
                : "none",
            }}>
              <span style={{
                display:"inline-block",
                background:`linear-gradient(90deg,${T.cyan},${T.goldLight},${T.cyanGlow},${T.cyan})`,
                backgroundSize:"300% auto",
                WebkitBackgroundClip:"text",
                WebkitTextFillColor:"transparent",
                backgroundClip:"text",
                animation:"shimmer-move 3.5s linear infinite",
                animationDelay:`${idx * 0.038}s`,
              }}>{ch}</span>
            </span>
          );
        })}
      </span>

      <span style={{display:"block"}}>
        {line3.split("").map((ch) => {
          const idx = gIdx++;
          return (
            <span key={`m${idx}`} style={{...charStyle(idx, 0.15), minWidth: ch===" " ? "0.3em" : undefined}}>
              {ch}
            </span>
          );
        })}
      </span>
    </h1>
  );
}

// ═══════════════════════════════════════════════════════
//  PAGE, ABOUT
// ═══════════════════════════════════════════════════════
function AboutPage({ setPage }) {
  const T = useT();
  const go=(p)=>{setPage(p);window.scrollTo({top:0,behavior:"instant"});};
  const [activeCard, setActiveCard] = useState(0);

  const heroCards = [
    { src: toothyzSquad,  label: "The Squad", border: T.cyan },
    { src: toothyzSquad2, label: "In the Wild", border: T.goldLight },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Update state on resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="relative z-10">
      <style>{`
        .about-diagonal-clip {
          clip-path: polygon(0 0, 100% 0, 100% 88%, 0 100%);
        }
        .about-diagonal-clip-rev {
          clip-path: polygon(0 5%, 100% 0, 100% 100%, 0 100%);
        }
        /* Wave shape bottom */
        .about-wave-clip {
          clip-path: ellipse(120% 100% at 50% 0%);
        }
        /* Diagonal parallelogram */
        .about-parallelogram-clip {
          clip-path: polygon(0 0, 100% 0, 100% 85%, 8% 100%);
        }
        /* Torn paper effect */
        .about-torn-clip {
          clip-path: polygon(0 0, 100% 0, 100% 92%, 95% 95%, 90% 91%, 85% 96%, 80% 92%, 75% 97%, 70% 93%, 65% 98%, 60% 93%, 55% 97%, 50% 92%, 45% 96%, 40% 91%, 35% 95%, 30% 90%, 25% 94%, 20% 89%, 15% 93%, 10% 88%, 5% 92%, 0 88%);
        }
        /* Arc clip */
        .about-arc-clip {
          clip-path: polygon(0 5%, 50% 0, 100% 5%, 100% 100%, 0 100%);
        }
        .about-tilt-card {
          transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease;
        }
        .about-tilt-card:hover {
          transform: translateY(-8px) rotate(0deg) !important;
        }
        .about-floating-badge {
          animation: about-badge-float 3s ease-in-out infinite;
        }
        @keyframes about-badge-float {
          0%,100% { transform: translateY(0) rotate(-2deg); }
          50% { transform: translateY(-10px) rotate(2deg); }
        }
        .about-card-swap {
          transition: transform 0.55s cubic-bezier(0.34,1.56,0.64,1), opacity 0.35s ease, box-shadow 0.35s ease;
        }
        .about-swap-btn {
          transition: transform 0.2s ease, background 0.2s ease;
        }
        .about-swap-btn:hover {
          transform: scale(1.12);
        }
        .about-movement-gif {
          animation: gif-float 3.5s ease-in-out infinite;
        }
        @keyframes gif-float {
          0%,100% { transform: translateY(0) rotate(-1deg); }
          50% { transform: translateY(-12px) rotate(1.5deg); }
        }
        .about-section-bg {
          position: relative;
          overflow: hidden;
        }
        .about-section-bg::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image: var(--section-bg);
          background-size: cover;
          background-position: center;
          background-attachment: fixed;
          opacity: 0.08;
          z-index: 0;
        }
        .about-section-content {
          position: relative;
          z-index: 1;
        }
        /* Book page turn feel */
        .about-chapter-label {
          writing-mode: vertical-rl;
          text-orientation: mixed;
          transform: rotate(180deg);
          letter-spacing: 0.2em;
          font-size: 0.6rem;
          font-weight: 900;
          text-transform: uppercase;
          opacity: 0.4;
        }
        .about-marquee-track {
          display: flex;
          gap: 32px;
          animation: about-marquee 18s linear infinite;
          white-space: nowrap;
        }
        @keyframes about-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .about-lore-card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .about-lore-card:hover {
          transform: translateX(8px);
        }
        .about-stat-ring {
          animation: about-ring-spin 8s linear infinite;
        }
        @keyframes about-ring-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>

      {/* ── CHAPTER 1: HERO ── */}
      <section className="relative overflow-hidden pt-32 pb-40 about-diagonal-clip"
        style={{
          backgroundImage: `url(${mainBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
        }}>
        {/* Dark overlay so text stays readable */}
        <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(135deg, rgba(4,13,26,0.88) 0%, rgba(4,13,26,0.75) 50%, rgba(8,20,40,0.82) 100%)",
          zIndex: 0,
        }}/>

        {/* Book chapter label on left edge */}
        <div className="absolute left-5 top-1/2 -translate-y-1/2 pointer-events-none hidden lg:flex flex-col items-center gap-3" style={{zIndex:2}}>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.cyan}60,transparent)`}}/>
          <span className="about-chapter-label" style={{color:T.cyan}}>Chapter One · The Movement</span>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.cyan}60,transparent)`}}/>
        </div>

        {/* Big decorative tooth */}
        <div className="absolute pointer-events-none hero-float"
          style={{right:"-40px",top:"10%",opacity:0.12,zIndex:1}}>
          <img src={toothyzPng} alt="" style={{width:340,height:340,objectFit:"contain"}}/>
        </div>

        <Spark size={40} color={T.cyanGlow}  className="absolute top-20 right-16 spin-slow" style={{opacity:0.8,zIndex:2}}/>
        <Spark size={24} color={T.goldLight} className="absolute bottom-32 left-24 spin-slow" style={{opacity:0.7,animationDirection:"reverse",zIndex:2}}/>

        <div className="max-w-6xl mx-auto px-5 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left copy */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-6 popup-zoom"
                style={{background:`${T.cyan}15`,border:`1px solid ${T.cyan}40`,backdropFilter:"blur(8px)"}}>
                <span className="text-xs font-black tracking-widest uppercase" style={{color:T.cyan}}>The Movement</span>
                <Spark size={10} color={T.goldLight} className="spin-slow"/>
              </div>

              <AboutHeroTitle/>

              <p className="text-lg leading-relaxed mb-10 max-w-xl" style={{color:T.textBody}}>
                Toothyz is more than a toy. It is a community of collectors, fans, and characters who believe your favourite icons deserve to exist in the softest, most huggable form possible.
              </p>

              {/* Stat cards row — layout unchanged */}
              <div className="relative" style={{paddingBottom: 8}}>
                <div className="flex flex-wrap gap-4 items-center">
                  {[
                    {v:"10K+", l:"Collectors", c:T.cyan,     rot:"-2deg"},
                    {v:"4.9★", l:"Avg Rating",  c:T.goldLight, rot:"1.5deg"},
                    {v:"20+",  l:"Plushies",    c:T.pink,      rot:"-1deg"},
                  ].map((s,i)=>(
                    <div key={i} className="about-tilt-card rounded-2xl px-6 py-4 text-center popup-bounce"
                      style={{background:T.bgCard,border:`1.5px solid ${s.c}35`,
                        boxShadow:`${T.shadowSm},0 0 20px ${s.c}12`,
                        transform:`rotate(${s.rot})`,animationDelay:`${i*0.12}s`}}>
                      <p className="font-black text-3xl" style={{fontFamily:"'Bubblegum Sans',cursive",color:s.c,
                        textShadow:T.dark?`0 0 16px ${s.c}66`:"none"}}>{s.v}</p>
                      <p className="text-xs font-bold mt-1" style={{color:T.textBody}}>{s.l}</p>
                    </div>
                  ))}
                </div>

                {/* movementGif — absolutely positioned, floats freely, no layout impact */}
                <div className="about-movement-gif"
                  style={{
                    position: "absolute",
                    bottom: isMobile ? -100 : -310, // Adjusts based on screen size
                    left: isMobile ? 70 : 10,       // Center it or nudge it on mobile
                    width: isMobile ? 300 : 500,   // Shrink it so it doesn't overflow
                    height: isMobile ? 300 : 500,
                    pointerEvents: "none",
                  }}>
                  <img src={movementGif} alt="Movement"
                    style={{width:"100%", height:"100%", objectFit:"contain"}}/>
                </div>
              </div>
            </div>

            {/* Right — enlarged swappable stacked cards */}
            <div className="relative flex justify-center items-center" style={{height:440}}>
              {/* Tap to swap hint */}
              <div className="absolute pointer-events-none"
                style={{top:-28,left:"50%",transform:"translateX(-50%)",
                  fontSize:"0.6rem",fontWeight:900,color:T.textDim,
                  letterSpacing:"0.15em",textTransform:"uppercase",whiteSpace:"nowrap"}}>
                Tap to swap ↕
              </div>

              {/* Back card */}
              <div className="absolute about-card-swap rounded-[28px] overflow-hidden cursor-pointer"
                style={{
                  width:320, height:360,
                  transform: activeCard===0 ? "rotate(6deg) translate(40px,-14px)" : "rotate(-5deg) translate(-35px,12px)",
                  border:`2.5px solid ${heroCards[1].border}35`,
                  boxShadow:`${T.shadowMd},0 0 30px ${heroCards[1].border}15`,
                  zIndex: activeCard===0 ? 1 : 3,
                  opacity: activeCard===0 ? 0.82 : 1,
                }}
                onClick={()=>setActiveCard(1)}>
                <img src={heroCards[1].src} alt="Toothyz" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                <div style={{position:"absolute",inset:0,background:"linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 50%)"}}/>
                <div style={{
                  position:"absolute",bottom:12,left:0,right:0,textAlign:"center",
                  fontFamily:"'Bubblegum Sans',cursive",fontSize:"0.85rem",color:"white",
                  fontWeight:900,letterSpacing:"0.08em",textShadow:"0 1px 8px rgba(0,0,0,0.8)",
                }}>{heroCards[1].label}</div>
              </div>

              {/* Front card */}
              <div className="absolute about-card-swap rounded-[28px] overflow-hidden cursor-pointer"
                style={{
                  width:320, height:360,
                  transform: activeCard===0 ? "rotate(-4deg) translate(-25px,14px)" : "rotate(5deg) translate(32px,-12px)",
                  border:`2.5px solid ${heroCards[0].border}50`,
                  boxShadow:`${T.shadowLg},0 0 40px ${heroCards[0].border}20`,
                  zIndex: activeCard===0 ? 3 : 1,
                  opacity: activeCard===0 ? 1 : 0.82,
                }}
                onClick={()=>setActiveCard(0)}>
                <img src={heroCards[0].src} alt="Toothyz Story" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                <div style={{position:"absolute",inset:0,background:"linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 50%)"}}/>
                <div style={{
                  position:"absolute",bottom:12,left:0,right:0,textAlign:"center",
                  fontFamily:"'Bubblegum Sans',cursive",fontSize:"0.85rem",color:"white",
                  fontWeight:900,letterSpacing:"0.08em",textShadow:"0 1px 8px rgba(0,0,0,0.8)",
                }}>{heroCards[0].label}</div>
              </div>

              {/* Swap dots */}
              <div className="absolute flex gap-2"
                style={{bottom:-30,left:"50%",transform:"translateX(-50%)",zIndex:5}}>
                {heroCards.map((_,i)=>(
                  <button key={i} className="about-swap-btn rounded-full"
                    onClick={()=>setActiveCard(i)}
                    style={{
                      width: activeCard===i ? 24 : 8, height:8,
                      background: activeCard===i ? T.cyan : `${T.cyan}40`,
                      border:"none", cursor:"pointer", borderRadius:4,
                    }}/>
                ))}
              </div>

              {/* Floating badge */}
              <div className="about-floating-badge absolute rounded-2xl px-4 py-2 text-center"
                style={{zIndex:5,bottom:-14,right:"0%",background:T.bgCard,
                  border:`1.5px solid ${T.pink}55`,boxShadow:`${T.shadowSm},0 0 20px ${T.pink}20`}}>
                <p className="text-xs font-black" style={{color:T.pink}}>Est. 2024 🦷</p>
                <p className="text-xs" style={{color:T.textDim}}>Contact@toothyz.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── MARQUEE TICKER — fun brand values ── */}
      <div className="overflow-hidden py-4 relative z-10"
        style={{background:`linear-gradient(90deg,${T.cyan},${T.cyanBright})`,borderTop:`2px solid ${T.cyanGlow}`,borderBottom:`2px solid ${T.cyanGlow}`}}>
        <div className="about-marquee-track">
          {[...Array(2)].map((_,rep)=>(
            ["🦷 Soft & Huggable","✦ Pop-Culture Iconic","🧸 Collectible Grade","💛 Gift-Ready","🎮 Fan-Favourite Characters","🔮 Limited Drops","🏆 Collector's Editions","✨ Tooth-Shaped Magic"].map((t,i)=>(
              <span key={`${rep}-${i}`} className="font-black text-sm tracking-widest uppercase"
                style={{color:"#040D1A",whiteSpace:"nowrap",flexShrink:0}}>{t}</span>
            ))
          ))}
        </div>
      </div>

      {/* ── CHAPTER 2: BENTO GRID — Vision & Community ── */}
      <section className="py-24 px-5 about-arc-clip relative overflow-hidden z-10"
        style={{
          backgroundImage: `url(${mainBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(160deg, rgba(8,20,40,0.92) 0%, rgba(4,13,26,0.85) 60%, rgba(12,30,58,0.90) 100%)",
          zIndex: 0,
        }}/>
        {/* Chapter label */}
        <div className="absolute left-5 top-1/2 -translate-y-1/2 pointer-events-none hidden lg:flex flex-col items-center gap-3" style={{zIndex:2}}>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.pink}60,transparent)`}}/>
          <span className="about-chapter-label" style={{color:T.pink}}>Chapter Two · The Vision</span>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.pink}60,transparent)`}}/>
        </div>
        <div className="relative z-10 max-w-5xl mx-auto">

          {/* Bento layout: asymmetric grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">

            {/* Wide card — The Vision */}
            <div className="md:col-span-2 rounded-[32px] p-8 relative overflow-hidden popup-left"
              style={{background:T.bgCard,border:`1.5px solid ${T.pink}25`,boxShadow:`${T.shadowMd},0 0 24px ${T.pink}08`}}>
              <div className="absolute top-0 right-0 w-32 h-32 pointer-events-none"
                style={{background:`radial-gradient(circle at top right,${T.pink}15 0%,transparent 70%)`}}/>
              <span className="text-xs font-black tracking-widest uppercase px-3 py-1.5 rounded-full mb-5 inline-block"
                style={{background:`${T.pink}15`,color:T.pink,border:`1px solid ${T.pink}30`}}>The Vision</span>
              <h3 className="font-black text-2xl mb-4"
                style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead,lineHeight:1.2}}>
                Characters Deserve to Be<br/><span style={{color:T.pink}}>Held, Not Just Seen.</span>
              </h3>
              <p className="text-sm leading-relaxed mb-3" style={{color:T.textBody}}>
                Toothyz started with a simple belief: the characters we grow up with deserve a physical form that's warm, tactile, and genuinely joyful. Not a poster. Something you can hold.
              </p>
              <p className="text-sm leading-relaxed" style={{color:T.textBody}}>
                Every Toothyz is an act of devotion to the stories and icons that matter. If a character means something to you, it belongs in your hands.
              </p>
            </div>

            {/* Tall narrow card — stat ring */}
            <div className="rounded-[32px] p-8 flex flex-col items-center justify-center relative overflow-hidden popup-right"
              style={{background:`linear-gradient(145deg,${T.bgCard},${T.bgCardHi})`,
                border:`1.5px solid ${T.cyan}30`,boxShadow:`${T.shadowMd},0 0 30px ${T.cyan}10`,minHeight:220}}>
              <div className="absolute inset-0 pointer-events-none"
                style={{background:`radial-gradient(circle at 50% 50%,${T.cyanBright}08 0%,transparent 70%)`}}/>
              <img src={toothyzPng} width={200}/>
              <p className="font-black text-sm text-center" style={{color:T.cyan,letterSpacing:"0.1em",textTransform:"uppercase"}}>
                Plush · Soft · Iconic
              </p>
              <p className="text-xs text-center mt-2" style={{color:T.textDim}}>
                Tooth-shaped, collectible, adored.
              </p>
            </div>
          </div>

          {/* Second row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Narrow — quote */}
            <div className="rounded-[32px] p-8 flex flex-col justify-between relative overflow-hidden popup-left"
              style={{background:`linear-gradient(145deg,${T.bgCard},${T.bgCardHi})`,
                border:`1.5px solid ${T.goldLight}25`,boxShadow:`${T.shadowMd},0 0 24px ${T.goldLight}08`,minHeight:220}}>
              <Spark size={30} color={T.goldLight} className="spin-slow mb-4" style={{opacity:0.7}}/>
              <blockquote className="font-black text-xl leading-tight"
                style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead}}>
                "Fandom you<br/>can actually<br/><span style={{color:T.goldLight}}>hold."</span>
              </blockquote>
              <p className="text-xs mt-4" style={{color:T.textDim}}>— The Toothyz Mission</p>
            </div>

            {/* Wide — Community */}
            <div className="md:col-span-2 rounded-[32px] p-8 relative overflow-hidden popup-right"
              style={{background:T.bgCard,border:`1.5px solid ${T.cyan}25`,boxShadow:`${T.shadowMd},0 0 24px ${T.cyanBright}08`}}>
              <div className="absolute bottom-0 left-0 w-32 h-32 pointer-events-none"
                style={{background:`radial-gradient(circle at bottom left,${T.cyan}12 0%,transparent 70%)`}}/>
              <span className="text-xs font-black tracking-widest uppercase px-3 py-1.5 rounded-full mb-5 inline-block"
                style={{background:`${T.cyan}12`,color:T.cyan,border:`1px solid ${T.cyan}30`}}>The Community</span>
              <h3 className="font-black text-2xl mb-4"
                style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead,lineHeight:1.2}}>
                Collectors Who <span style={{color:T.cyanBright}}>Get It.</span>
              </h3>
              <p className="text-sm leading-relaxed mb-3" style={{color:T.textBody}}>
                The Toothyz community is built around one shared truth: you never really stop loving the characters that shaped you. Collectors range from kids to adults, casual fans to obsessives.
              </p>
              <p className="text-sm leading-relaxed" style={{color:T.textBody}}>
                Every new drop brings the community together. Limited runs spark real excitement. A new character reveal is an event.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CHAPTER 3: LORE ── */}
      <section className="py-24 px-5 about-torn-clip relative overflow-hidden"
        style={{
          backgroundImage: `url(${aboutBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(180deg, rgba(4,13,26,0.90) 0%, rgba(0,4,20,0.82) 50%, rgba(4,13,26,0.90) 100%)",
          zIndex: 0,
        }}/>
        {/* Chapter label */}
        <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none hidden lg:flex flex-col items-center gap-3" style={{zIndex:2}}>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.cyanGlow}60,transparent)`}}/>
          <span className="about-chapter-label" style={{color:T.cyanGlow}}>Chapter Three · The Lore</span>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.cyanGlow}60,transparent)`}}/>
        </div>
        <div className="relative z-10 max-w-5xl mx-auto">
          <SectionHead eyebrow="Meet the Icons" title="Every Toothyz Has a Story"
            sub="Beyond the plush, each character carries a little piece of lore on their collectible card."/>
          <div className="space-y-4">
            {LORE.map((l,i)=>(
              <div key={i} className="about-lore-card flex gap-5 items-start rounded-3xl p-6"
                style={{background:T.bgCard,
                  border:`1.5px solid ${l.color}25`,
                  boxShadow:`${T.shadowSm},0 0 20px ${l.color}08`,
                  borderLeft:`4px solid ${l.color}`}}>
                <div className="flex-shrink-0 w-16 h-16 rounded-2xl overflow-hidden"
                  style={{border:`1.5px solid ${l.color}40`}}>
                  <img src={l.charimg} alt={l.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-1.5 flex-wrap">
                    <h3 className="font-black text-xl"
                      style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead}}>{l.name}</h3>
                    <span className="text-xs font-black px-2.5 py-0.5 rounded-full"
                      style={{background:`${l.color}18`,color:l.color,border:`1px solid ${l.color}30`}}>{l.tag}</span>
                  </div>
                  <p className="text-sm leading-relaxed" style={{color:T.textBody}}>{l.story}</p>
                </div>
                {/* Index number decoration */}
                <div className="flex-shrink-0 font-black text-4xl opacity-10 self-center"
                  style={{fontFamily:"'Bubblegum Sans',cursive",color:l.color}}>
                  {String(i+1).padStart(2,"0")}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CHAPTER 4: TRUST + REGISTRATION ── */}
      <section className="py-20 px-5 about-parallelogram-clip relative overflow-hidden"
        style={{
          backgroundImage: `url(${mainBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center bottom",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(135deg, rgba(8,20,40,0.93) 0%, rgba(4,13,26,0.86) 50%, rgba(12,30,58,0.92) 100%)",
          zIndex: 0,
        }}/>
        {/* Chapter label — book feel */}
        <div className="absolute right-5 top-1/2 -translate-y-1/2 pointer-events-none hidden lg:flex flex-col items-center gap-3" style={{zIndex:2}}>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.goldLight}60,transparent)`}}/>
          <span className="about-chapter-label" style={{color:T.goldLight,transform:"rotate(0deg)"}}>Chapter Four · The Brand</span>
          <div style={{width:1,height:60,background:`linear-gradient(to bottom,transparent,${T.goldLight}60,transparent)`}}/>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto">
          <SectionHead eyebrow="Official & Registered" title="A Brand You Can Trust"
            sub="Toothyz is a fully registered trademark operating under A15HAQ LTD."/>
          
          {/* Overlapping card layout */}
          <div className="relative">
            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {[
                {title:"🧸 Class 28, Toys & Games",body:"Soft toys · Plush toys · Plush dolls · Stuffed toys · Teddy bears · Action figures.",c:T.cyan,rot:"1deg"},
              ].map((f,i)=>(
                <div key={i} className="about-tilt-card rounded-3xl p-8 text-left popup-bounce"
                  style={{background:T.bgCard,border:`1.5px solid ${f.c}20`,
                    boxShadow:`${T.shadowMd},0 0 20px ${f.c}10`,
                    animationDelay:`${i*0.15}s`,transform:`rotate(${f.rot})`}}>
                  <h3 className="font-black text-base mb-3"
                    style={{fontFamily:"'Bubblegum Sans',cursive",color:f.c}}>{f.title}</h3>
                  <p className="text-sm leading-relaxed" style={{color:T.textBody}}>{f.body}</p>
                </div>
              ))}
            </div>
            {/* Company pill */}
            <div className="rounded-2xl px-8 py-4 text-center popup-bounce"
              style={{background:T.bgCard,border:`1px solid ${T.border}`,animationDelay:"0.3s"}}>
              <p className="text-sm" style={{color:T.textBody}}>
                Registered in the name of <strong style={{color:T.cyan}}>A15HAQ LTD</strong> · Company Number <strong style={{color:T.cyan}}>SC650199</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── CHAPTER 5: FINAL CTA ── */}
      <section className="py-24 px-5 about-wave-clip relative overflow-hidden"
        style={{
          backgroundImage: `url(${shopBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          paddingBottom:"6rem",
        }}>
        <div className="absolute inset-0 pointer-events-none" style={{
          background: "linear-gradient(180deg, rgba(4,13,26,0.88) 0%, rgba(0,4,20,0.78) 50%, rgba(4,13,26,0.88) 100%)",
          zIndex: 0,
        }}/>
        {/* Background decorative large tooth */}
        <div className="absolute pointer-events-none" style={{left:"50%",top:"50%",transform:"translate(-50%,-50%)",opacity:0.06,zIndex:1}}>
          <img src={toothyzPng} alt="" style={{width:380,height:380,objectFit:"contain"}}/>
        </div>
        <div className="relative z-10 max-w-2xl mx-auto text-center">
          <img src={toothyzPng} alt="Toothyz" className="mx-auto mb-5 hero-float" style={{width:72,height:72,objectFit:"contain"}}/>
          <InlineScrollH2 text="Ready to Join the Movement?" color="#F0F8FF" fontSize="clamp(2rem,5vw,3rem)" center/>
          <p className="mb-8 text-base" style={{color:"rgba(186,230,253,0.85)"}}>
            Pick your character. Claim your piece of the movement. Your Toothyz is waiting.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <GlowBtn onClick={()=>go("shop")}>Shop Now 🛒</GlowBtn>
            <GlowBtn onClick={()=>go("characters")} secondary>See Plushies ✨</GlowBtn>
          </div>
        </div>
      </section>

      <Footer setPage={setPage}/>
    </div>
  );
}

// ═══════════════════════════════════════════════════════
//  PAGE, SHOP
// ═══════════════════════════════════════════════════════

// ── Product Detail Dialog ─────────────────────────────
function ProductDetailDialog({ product, onClose, onAddToCart, cartItem, onUpdateQuantity }) {
  const T = useT();
  const [activeImg, setActiveImg] = useState(0);
  const images = product.images || [];
  const variant = product.variants[0];
  const inCart = !!cartItem;

  useEffect(() => {
    const orig = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = orig; };
  }, []);

  const prev = () => setActiveImg(i => (i - 1 + images.length) % images.length);
  const next = () => setActiveImg(i => (i + 1) % images.length);

  const header = (
    <div className="flex items-center gap-3 w-full" style={{ fontFamily: "'Bubblegum Sans',cursive" }}>
      <div className="flex flex-col">
        <div className="text-xl font-black leading-tight text-black">{product.title}</div>
        <div className="text-[11px] font-black uppercase tracking-widest text-black/40">Product Details</div>
      </div>
      <div className="ml-auto mr-10">
        <span className="text-base font-black px-3 py-1.5 rounded-xl" style={{ background: T.gold, color: "#000" }}>
          {formatPrice(variant.price.amount, variant.price.currencyCode)}
        </span>
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        .shop-dialog.p-dialog {
          background: #FFFFFF !important;
          border-radius: 32px !important;
          box-shadow: 0 40px 120px -20px rgba(0,0,0,0.45) !important;
          border: none !important;
          overflow: hidden !important;
          width: 740px !important;
          max-width: 95vw !important;
          animation: dialog-pop 0.4s cubic-bezier(0.34,1.56,0.64,1) both !important;
        }
        @media (max-width: 639px) {
          .shop-dialog.p-dialog { width: 100vw !important; height: 100vh !important; max-height: 100vh !important; margin: 0 !important; border-radius: 0 !important; }
          .shop-dialog-layout { flex-direction: column !important; }
          .shop-dialog-left { width: 100% !important; border-right: none !important; border-bottom: 2px solid #F1F5F9 !important; }
        }
        .shop-dialog .p-dialog-header { background: #FFFFFF !important; padding: 24px !important; border-bottom: 2px solid #F8FAFC !important; }
        .shop-dialog .p-dialog-header-icons .p-dialog-header-close {
          background: #000 !important; color: #fff !important; border-radius: 12px !important;
          width: 32px !important; height: 32px !important; position: absolute !important;
          right: 24px !important; transition: all 0.2s ease;
        }
        .shop-dialog .p-dialog-header-icons .p-dialog-header-close:hover { transform: rotate(90deg) scale(1.1); }
        .shop-dialog .p-dialog-content { padding: 0 !important; background: #FFFFFF !important; }
        .shop-dialog .p-dialog-mask { backdrop-filter: blur(12px) !important; background: rgba(0,8,29,0.7) !important; }

        /* Layout */
        .shop-dialog-layout { display: flex; flex-direction: row; min-height: 460px; }
        .shop-dialog-left {
          width: 300px; flex-shrink: 0;
          background: #F8FAFC;
          border-right: 2px solid #F1F5F9;
          display: flex; flex-direction: column;
          padding: 20px; gap: 14px;
        }
        .shop-dialog-right {
          flex: 1; padding: 28px;
          display: flex; flex-direction: column;
          overflow-y: auto; max-height: 520px;
        }
        .shop-dialog-right::-webkit-scrollbar { width: 5px; }
        .shop-dialog-right::-webkit-scrollbar-thumb { background: #E2E8F0; border-radius: 10px; }

        /* Main image area */
        .sd-main-img-wrap {
          flex: 1; position: relative;
          display: flex; align-items: center; justify-content: center;
          min-height: 200px;
        }
        .sd-main-img-wrap img {
          max-width: 100%; max-height: 220px;
          object-fit: contain;
          filter: drop-shadow(0 12px 24px rgba(0,0,0,0.13));
          transition: opacity 0.2s ease;
        }
        .sd-arrow {
          position: absolute; top: 50%; transform: translateY(-50%);
          width: 30px; height: 30px; border-radius: 50%; border: none;
          background: rgba(255,255,255,0.9); box-shadow: 0 2px 8px rgba(0,0,0,0.12);
          cursor: pointer; font-size: 1.1rem; display: flex; align-items: center;
          justify-content: center; transition: all 0.2s; color: #334155;
        }
        .sd-arrow:hover { background: #fff; box-shadow: 0 4px 14px rgba(0,0,0,0.18); transform: translateY(-50%) scale(1.08); }
        .sd-arrow.left  { left: 4px; }
        .sd-arrow.right { right: 4px; }

        /* Thumbnail strip */
        .sd-thumbs {
          display: flex; gap: 8px; flex-wrap: wrap; justify-content: center;
        }
        .sd-thumb {
          width: 52px; height: 52px; border-radius: 12px; object-fit: cover;
          cursor: pointer; border: 2.5px solid transparent;
          transition: all 0.2s; opacity: 0.55; flex-shrink: 0;
          background: #fff;
        }
        .sd-thumb:hover { opacity: 0.85; }
        .sd-thumb.active {
          border-color: #0EA5E9; opacity: 1;
          box-shadow: 0 0 0 3px rgba(14,165,233,0.18);
        }

        /* Shopify HTML description styles */
        .sd-description { font-size: 14px; line-height: 1.75; color: #1E293B; font-weight: 600; }
        .sd-description p { margin-bottom: 12px; }
        .sd-description ul, .sd-description ol { padding-left: 18px; margin-bottom: 12px; }
        .sd-description li { margin-bottom: 4px; }
        .sd-description strong { font-weight: 800; color: #0F172A; }
        .sd-description a { color: #0EA5E9; text-decoration: underline; }
        .sd-description h1,.sd-description h2,.sd-description h3 { font-family: 'Bubblegum Sans',cursive; font-weight: 900; color: #0F172A; margin-bottom: 8px; }
      `}</style>

      <Dialog visible onHide={onClose} header={header} className="shop-dialog" modal dismissableMask blockScroll>
        <div className="shop-dialog-layout">

          {/* ── Left: Image + Thumbnails ── */}
          <div className="shop-dialog-left">

            {/* Main image */}
            <div className="sd-main-img-wrap">
              <img key={activeImg} src={images[activeImg]?.src} alt={product.title} />
              {images.length > 1 && (
                <>
                  <button className="sd-arrow left" onClick={prev}>‹</button>
                  <button className="sd-arrow right" onClick={next}>›</button>
                </>
              )}
            </div>

            {/* Thumbnail strip — only shown if 2+ images */}
            {images.length > 1 && (
              <div className="sd-thumbs">
                {images.map((img, i) => (
                  <img
                    key={i}
                    src={img.src}
                    alt={`View ${i + 1}`}
                    className={`sd-thumb${i === activeImg ? " active" : ""}`}
                    onClick={() => setActiveImg(i)}
                  />
                ))}
              </div>
            )}
          </div>

          {/* ── Right: Description + Actions ── */}
          <div className="shop-dialog-right">

            {/* Shopify description — rendered as HTML */}
            {product.descriptionHtml ? (
              <div
                className="sd-description"
                style={{ marginBottom: 20, flex: 1 }}
                dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
              />
            ) : product.description ? (
              <p className="sd-description" style={{ marginBottom: 20, flex: 1 }}>{product.description}</p>
            ) : (
              <p className="sd-description" style={{ marginBottom: 20, flex: 1, color: "#94A3B8", fontStyle: "italic" }}>
                No description available.
              </p>
            )}

            {/* Stock badge */}
            <div style={{ marginBottom: 16 }}>
              <span style={{
                fontSize: 12, fontWeight: 800, padding: "4px 12px", borderRadius: 20,
                background: variant.available ? "#DCFCE7" : "#FEE2E2",
                color: variant.available ? "#166534" : "#991B1B"
              }}>
                {variant.available ? "✅ In Stock" : "❌ Out of Stock"}
              </span>
            </div>

            {/* Cart actions */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {!variant.available ? (
                <button
                  disabled
                  style={{
                    width: "100%", padding: "14px 0", borderRadius: 18, border: "1.5px solid #E2E8F0",
                    fontFamily: "'Bubblegum Sans',cursive", fontWeight: 900, fontSize: 16,
                    cursor: "not-allowed", background: "#F1F5F9", color: "#94A3B8"
                  }}
                >
                  😢 Out of Stock
                </button>
              ) : inCart ? (
                <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#EFF6FF", borderRadius: 16, padding: "10px 16px", border: "1.5px solid #BAE6FD" }}>
                  <button onClick={() => onUpdateQuantity(variant.id, -1)}
                    style={{ width: 32, height: 32, borderRadius: "50%", border: "none", background: "#fff", fontWeight: 900, fontSize: 18, cursor: "pointer" }}>−</button>
                  <span style={{ flex: 1, textAlign: "center", fontWeight: 900, color: "#0369A1", fontFamily: "'Bubblegum Sans',cursive" }}>
                    {cartItem.quantity} in cart
                  </span>
                  <button onClick={() => onAddToCart(product)}
                    style={{ width: 32, height: 32, borderRadius: "50%", border: "none", background: "#0EA5E9", color: "#fff", fontWeight: 900, fontSize: 18, cursor: "pointer" }}>+</button>
                </div>
              ) : (
                <button onClick={() => { onAddToCart(product); onClose(); }}
                  style={{ width: "100%", padding: "14px 0", borderRadius: 18, border: "none", fontFamily: "'Bubblegum Sans',cursive", fontWeight: 900, fontSize: 16, cursor: "pointer", background: "linear-gradient(135deg,#0EA5E9,#38BDF8)", color: "#00081d", boxShadow: "0 8px 20px rgba(14,165,233,0.35)" }}>
                  Adopt Me 🛒
                </button>
              )}
              <button onClick={onClose}
                style={{ width: "100%", padding: "12px 0", borderRadius: 18, border: "1.5px solid #E2E8F0", fontFamily: "'Bubblegum Sans',cursive", fontWeight: 900, fontSize: 14, cursor: "pointer", background: "#fff", color: "#64748B" }}>
                Close
              </button>
            </div>
          </div>

        </div>
      </Dialog>
    </>
  );
}

function ShopPage({ setPage, isLoading = false }) {
  const T = useT();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // ── CART STATE ──
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [detailProduct, setDetailProduct] = useState(null);

  // ── Terminal panel zoom scale + mobile wrap width ──
  // Zoom: initialHeight × scale = 70vh (mobile) / 90vh (desktop)
  // Mobile width: initialWidth × scale = 95vw  →  initialWidth = 95vw / scale
  const [zoomScale, setZoomScale] = useState(1.32);
  const [mobileWrapPx, setMobileWrapPx] = useState(null);
  useEffect(() => {
    const calcZoom = () => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const isMobile = vw < 640;
      let initialHeight;
      if (isMobile) {
        // Mobile panel: height: 54vh, min 260px
        initialHeight = Math.max(260, 0.54 * vh);
        const scale = (0.70 * vh) / initialHeight;
        // Back-calculate the initial width so zoomed width = 95vw
        const wrapPx = Math.round((0.95 * vw) / scale);
        setMobileWrapPx(wrapPx);
        setZoomScale(parseFloat(scale.toFixed(4)));
      } else {
        // Desktop/tablet: aspect-ratio 16/9.2, width = min(1180, 96vw)
        const panelWidth = Math.min(1180, 0.96 * vw);
        initialHeight = panelWidth * (9.2 / 16);
        const scale = (0.90 * vh) / initialHeight;
        setMobileWrapPx(null);
        setZoomScale(parseFloat(scale.toFixed(4)));
      }
    };
    calcZoom();
    window.addEventListener("resize", calcZoom);
    return () => window.removeEventListener("resize", calcZoom);
  }, []);

  // ── Fetch Products on Mount ──
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const fetchedProducts = await client.product.fetchAll();
        setProducts(fetchedProducts);
      } catch (err) {
        console.error("Shopify fetch failed:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // ── Auto-remove out-of-stock items from cart when products load ──
  useEffect(() => {
    if (products.length > 0) {
      setCart(prev => prev.filter(item => {
        const product = products.find(p => p.variants[0].id === item.variantId);
        return product ? product.variants[0].available : true;
      }));
    }
  }, [products]);

  // ── CART HELPERS ──
  const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);
  const cartTotal = cart.reduce((acc, item) => acc + parseFloat(item.price) * item.quantity, 0).toFixed(2);
  const getCartItem = (variantId) => cart.find((item) => item.variantId === variantId);

  const addToCart = (product) => {
    const variant = product.variants[0];
    if (!variant.available) return;
    const existing = cart.find(item => item.variantId === variant.id);
    if (existing) {
      setCart(cart.map(item =>
        item.variantId === variant.id ? { ...item, quantity: item.quantity + 1 } : item
      ));
    } else {
      setCart([...cart, {
        variantId: variant.id,
        title: product.title,
        price: variant.price.amount,
        currencyCode: variant.price.currencyCode,
        image: product.images[0]?.src,
        quantity: 1,
        available: variant.available,
      }]);
    }
    setIsCartOpen(true);
  };

  const updateQuantity = (variantId, delta) => {
    setCart(prev =>
      prev
        .map(item => item.variantId === variantId ? { ...item, quantity: item.quantity + delta } : item)
        .filter(item => item.quantity > 0)
    );
  };

  // ── CHECKOUT ──
  const handleCheckout = async () => {
    setIsCheckingOut(true);
    try {
      const checkout = await client.checkout.create();
      const lineItemsToAdd = cart
        .filter(item => item.available !== false)
        .map(item => ({ variantId: item.variantId, quantity: item.quantity }));
      const updatedCheckout = await client.checkout.addLineItems(checkout.id, lineItemsToAdd);
      window.location.href = updatedCheckout.webUrl;
    } catch (err) {
      console.error("Checkout error:", err);
      setIsCheckingOut(false);
    }
  };

  const go = (p) => { setPage(p); window.scrollTo({ top: 0, behavior: "instant" }); };

  // ── Character image columns (no Shopify needed) ──
  const allChars = [
    { src: rectangleBlue },
    { src: rectangleLandscapeLemon },
    { src: rectangleVerticalLightOrange },
    { src: rectangleVerticalPink },
    { src: squareCyan },
    { src: squareGreen },
    { src: squareLightViolet },
    { src: squareYellow },
  ];

  // Size patterns per column: "rect" = portrait 3/4, "sq" = square 1/1
  const sizePatterns = [
    ["rect","sq",  "rect","rect","sq",  "rect"],  // col 1
    ["sq",  "rect","sq",  "rect","rect","sq"  ],  // col 2
    ["rect","rect","sq",  "sq",  "rect","rect"],  // col 3
    ["sq",  "rect","rect","sq",  "sq",  "rect"],  // col 4
  ];

  // Distribute into 4 columns, each with its own repeating set + sizes
  const makeCol = (indices, sizes) => {
    const base = indices.map((idx, j) => ({
      ...allChars[idx % allChars.length],
      size: sizes[j % sizes.length],
    }));
    // Triplicate so infinite scroll never runs out
    return [...base, ...base, ...base];
  };
  const charCols = [
    makeCol([0, 3, 6, 9,  12, 1], sizePatterns[0]),   // col 1 – scrolls DOWN
    makeCol([1, 4, 7, 10, 13, 2], sizePatterns[1]),   // col 2 – scrolls UP
    makeCol([2, 5, 8, 11, 14, 3], sizePatterns[2]),   // col 3 – scrolls DOWN
    makeCol([0, 6, 9, 12,  4, 7], sizePatterns[3]),   // col 4 – scrolls UP
  ];

  // ── CART DIALOG HEADER ──
  const cartHeader = (
    <div className="flex items-center gap-3 w-full">
      <span style={{ fontFamily: "'Bubblegum Sans', cursive", fontSize: "1.5rem", fontWeight: 900, color: "#111" }}>
        Your Cart
      </span>
      {totalItems > 0 && (
        <span className="text-xs font-black px-2 py-0.5 rounded-full text-black" style={{ background: T.gold }}>
          {totalItems}
        </span>
      )}
    </div>
  );

  return (
    <div className="relative z-10">

      {/* ═══════════════════════════════════════════════════════════════════
          CINEMATIC PREVIEW — dark room · wide panel · grid images · light-up
          Animation sequence:
            0.0s  panel rises from dark
            1.4s  panel BORDER lights up (blue glow)
            2.0s  outer halo blooms
            2.4s  room background reveals (furniture, walls)
            2.2s  grid content fades in
            3.2s  grid begins scrolling up/down
            3.5s  "scroll to shop" cue appears
      ═══════════════════════════════════════════════════════════════════ */}
      <section className={isLoading ? "ci-frozen" : ""} style={{
        width: "100%",
        minHeight: "100vh",
        background: "transparent",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <style>{`

          /* ──────────── FREEZE all child animations while loading overlay is up ──────────── */
          .ci-frozen * {
            animation-play-state: paused !important;
          }
          /* Un-freeze the moment loading lifts — transition kicks back in */
          :not(.ci-frozen) .ci-panel,
          :not(.ci-frozen) .ci-panel-halo,
          :not(.ci-frozen) .ci-panel-wrap,
          :not(.ci-frozen) .ci-grid-outer,
          :not(.ci-frozen) [class^="ci-"] {
            animation-play-state: running;
          }





          /* ──────────── PANEL ──────────── */



          /* halo blooms after border */
          .ci-panel-halo {
            position:absolute; inset:-70px;
            border-radius:52px;
            background:radial-gradient(ellipse at 50% 50%,
              rgba(70,110,255,0.22) 0%,
              rgba(55,90,220,0.1)  38%,
              transparent 62%
            );
            opacity:0; pointer-events:none;
            animation: ci-halo-in 1.8s ease-out 2s forwards,
                       ci-halo-breathe 4s ease-in-out 3.8s infinite;
          }
          @keyframes ci-halo-in     { from{opacity:0} to{opacity:1} }
          @keyframes ci-halo-breathe {
            0%,100%{transform:scale(1); opacity:0.8;}
            50%    {transform:scale(1.05); opacity:1;}
          }

          /* floor glow under panel */
          .ci-floor-glow {
            position:absolute;
            bottom:-50px; left:50%;
            transform:translateX(-50%);
            width:70%; height:80px;
            background:radial-gradient(ellipse, rgba(70,110,255,0.18) 0%, transparent 70%);
            filter:blur(20px);
            opacity:0; pointer-events:none;
            animation: ci-halo-in 1.4s ease-out 2.2s forwards,
                       ci-halo-breathe 4s ease-in-out 3.8s infinite;
          }

          .ci-panel {
            width:100%;
            aspect-ratio: 16 / 9.2;
            background: rgba(3,4,18,0.12);
            backdrop-filter: blur(6px) saturate(1.3);
            -webkit-backdrop-filter: blur(6px) saturate(1.3);
            border-radius: 20px;
            position:relative; overflow:hidden;
            display:flex; flex-direction:column;

            /* starts dim */
            border: 1.5px solid rgba(80,110,255,0.07);
            box-shadow: none;

            /* STEP: border lights up */
            animation:
              ci-border-light 1s ease-out 1.4s forwards,
              ci-panel-breathe 4s ease-in-out 2.8s infinite;
          }
          @keyframes ci-border-light {
            from {
              border-color: rgba(80,110,255,0.07);
              box-shadow: none;
            }
            to {
              border-color: rgba(120,155,255,0.55);
              box-shadow:
                0 0 0 1px rgba(90,130,255,0.14),
                0 0 70px rgba(70,110,255,0.3),
                0 0 160px rgba(55,90,220,0.18),
                inset 0 0 55px rgba(60,100,255,0.07);
            }
          }
          @keyframes ci-panel-breathe {
            0%,100% {
              box-shadow:
                0 0 0 1px rgba(90,130,255,0.14),
                0 0 70px rgba(70,110,255,0.28),
                0 0 150px rgba(55,90,220,0.16),
                inset 0 0 50px rgba(60,100,255,0.06);
            }
            50% {
              box-shadow:
                0 0 0 1px rgba(90,130,255,0.22),
                0 0 110px rgba(70,110,255,0.42),
                0 0 240px rgba(55,90,220,0.26),
                inset 0 0 80px rgba(60,100,255,0.11);
            }
          }

          /* chrome top bar — glass */
          .ci-chrome {
            flex-shrink:0; height:26px;
            background:rgba(8,11,30,0.30);
            border-bottom:1px solid rgba(255,255,255,0.10);
            display:flex; align-items:center; gap:5px; padding:0 12px;
          }
          .ci-chrome-dot { width:8px; height:8px; border-radius:50%; }
          .ci-chrome-bar { flex:1; height:5px; border-radius:3px; background:rgba(255,255,255,0.04); }
          .ci-chrome-pill { height:11px; width:55px; border-radius:6px; background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.05); }

          /* scanlines removed for performance */

          /* inner vignettes — transparent so panel glass shows through */
          .ci-vig-top { position:absolute; top:26px; left:0; right:0; height:80px; background:linear-gradient(to bottom,rgba(3,4,14,0.45),transparent); z-index:3; pointer-events:none; }
          .ci-vig-bot { position:absolute; bottom:0; left:0; right:0; height:90px; background:linear-gradient(to top,rgba(3,4,14,0.45),transparent);    z-index:3; pointer-events:none; }
          .ci-vig-l   { position:absolute; top:26px; left:0; bottom:0; width:55px; background:linear-gradient(to right,rgba(3,4,14,0.35),transparent);  z-index:3; pointer-events:none; }
          .ci-vig-r   { position:absolute; top:26px; right:0; bottom:0; width:55px; background:linear-gradient(to left,rgba(3,4,14,0.35),transparent);   z-index:3; pointer-events:none; }

          /* ──────────── GRID (4 independent columns) ──────────── */

          .ci-grid-outer {
            flex:1; overflow:hidden; position:relative;
          }

          /* Flex row containing 4 equal columns */
          .ci-cols {
            display:flex;
            gap:8px;
            padding:10px;
            height:100%;
          }

          /* Each column is a clipping window */
          .ci-col {
            flex:1; overflow:hidden; position:relative;
            contain:strict;
          }

          /* The inner strip that actually moves */
          .ci-col-inner {
            display:flex;
            flex-direction:column;
            gap:8px;
            will-change:transform;
            transform:translateZ(0);
          }

          /* Columns appear at mid-zoom (1.7s = 1.25s + 0.425s) */
          .ci-col:nth-child(odd) .ci-col-inner {
            opacity: 0;
            transform: translateY(20%);
            animation: ci-col-enter-up 0.75s cubic-bezier(0.22,1,0.36,1) 1.7s forwards;
          }
          @keyframes ci-col-enter-up {
            from { opacity: 0; transform: translateY(20%); }
            to   { opacity: 1; transform: translateY(-33.33%); }
          }

          .ci-col:nth-child(even) .ci-col-inner {
            opacity: 0;
            transform: translateY(-55%);
            animation: ci-col-enter-down 0.75s cubic-bezier(0.22,1,0.36,1) 1.7s forwards;
          }
          @keyframes ci-col-enter-down {
            from { opacity: 0; transform: translateY(-55%); }
            to   { opacity: 1; transform: translateY(-33.33%); }
          }

          /* Individual image cards — clean */
          .ci-cell {
            border-radius:10px; overflow:hidden;
            background:transparent;
            border:none;
            position:relative;
            flex-shrink:0;
          }
          .ci-cell img {
            width:100%; height:100%;
            object-fit:cover; object-position:center top;
            display:block; opacity:1;
          }

          /* Size variants */
          .ci-cell--rect { aspect-ratio: 3/4; }
          .ci-cell--sq   { aspect-ratio: 1/1; }

          /* badge labels */
          .ci-badge {
            position:absolute; bottom:6px; left:6px;
            padding:2px 7px; border-radius:20px;
            font-family:'Nunito',sans-serif;
            font-size:9px; font-weight:900; letter-spacing:0.06em;
            background:rgba(0,0,0,0.65); color:rgba(255,255,255,0.72);
            border:1px solid rgba(255,255,255,0.08);
            z-index:2;
          }

          /* ──────────── TWO WHITE LINES — counter-clockwise sweep ──────────── */
          /* Rect perimeter ≈ 3136px. Two 300px dashes:
             Line 1: top edge  50px from left  → path pos  50–350
             Line 2: bottom edge 50px from right → path pos 1618–1918
             dasharray: 300,1268,300,1268  (gaps = (1618-350)=1268 and (3136+50-1918)=1268)
             Initial dashoffset: -50 (shifts pattern so Dash1 starts at 50px)
             CCW one revolution: -50 → 3086 (= -50 + 3136)
             Sweep starts with zoom at 1.25s, lasts 0.8s.
             Fade: 0.15s at 2.0s → fully gone by 2.15s.                         */
          .ci-sweep-svg {
            position: absolute;
            top: 0; left: 0; width: 100%;
            aspect-ratio: 16 / 9.2;
            z-index: 25; pointer-events: none;
            overflow: visible;
          }
          .ci-sweep-line {
            fill: none;
            stroke: white;
            stroke-width: 3;
            stroke-linecap: round;
            stroke-dasharray: 300 1268 300 1268;
            stroke-dashoffset: -50;
            opacity: 1;
            filter: drop-shadow(0 0 6px rgba(255,255,255,1))
                    drop-shadow(0 0 20px rgba(255,255,255,0.8));
            animation:
              ci-sweep-ccw  0.8s linear   1.25s forwards,
              ci-sweep-fade 0.15s ease-in 2.0s  forwards;
          }
          @keyframes ci-sweep-ccw {
            from { stroke-dashoffset: -50; }
            to   { stroke-dashoffset: 3086; }
          }
          @keyframes ci-sweep-fade {
            from { opacity: 1; }
            to   { opacity: 0; }
          }

          /* ──────────── PANEL: RISE then ZOOM immediately ──────────── */
          /* Rise: 0.15s delay, 1.1s → done at 1.25s
             Zoom: starts at 1.25s (no gap), 0.85s → done at 2.1s              */
          .ci-panel-wrap {
            position:relative; z-index:10;
            width: min(1180px, 96vw);
            transform-origin: center center;
            animation:
              ci-panel-rise 1.1s cubic-bezier(0.22,1,0.36,1) 0.15s both,
              ci-panel-zoom 0.85s cubic-bezier(0.34,1.2,0.64,1) 1.25s forwards;
          }
          @keyframes ci-panel-rise {
            from{opacity:0; transform:scale(0.72); filter:blur(6px);}
            to  {opacity:1; transform:scale(1);    filter:blur(0);}
          }
          @keyframes ci-panel-zoom {
            from { transform: scale(1); }
            to   { transform: scale(${zoomScale}); }
          }



          /* floating orb pulses for hologram */
          @keyframes ci-orb-pulse {
            0%,100%{transform:scale(1);   opacity:0.55;}
            50%    {transform:scale(1.25);opacity:0.85;}
          }
          @keyframes ci-orb-drift {
            0%  {transform:translateY(0px)  rotate(0deg);}
            33% {transform:translateY(-18px) rotate(8deg);}
            66% {transform:translateY(-8px) rotate(-5deg);}
            100%{transform:translateY(0px)  rotate(0deg);}
          }
          @keyframes ci-spark-twinkle {
            0%,100%{opacity:0.3;transform:scale(0.8) rotate(0deg);}
            50%    {opacity:1;  transform:scale(1.2) rotate(20deg);}
          }
          @keyframes ci-wave-drift {
            0%  {transform:translateX(0);}
            100%{transform:translateX(-50%);}
          }
          @keyframes ci-confetti-fall {
            0%  {transform:translateY(-20px) rotate(0deg);   opacity:0;}
            10% {opacity:0.9;}
            100%{transform:translateY(120px) rotate(360deg); opacity:0;}
          }

          /* bottom reflection */
          .ci-reflect {
            position:absolute; bottom:-18px; left:50%;
            transform:translateX(-50%);
            width:78%; height:1px;
            background:linear-gradient(to right,transparent,rgba(100,140,255,0.45),transparent);
          }
          .ci-reflect::after {
            content:''; position:absolute;
            top:1px; left:8%; right:8%; height:12px;
            background:radial-gradient(ellipse,rgba(100,140,255,0.16) 0%,transparent 100%);
            filter:blur(5px);
          }

          /* scroll cue */
          .ci-cue {
            position:absolute; bottom:22px; left:50%;
            transform:translateX(-50%);
            display:flex; flex-direction:column; align-items:center; gap:6px;
            z-index:20; opacity:0;
            animation:ci-cue-in 1s ease 2.5s forwards;
          }
          @keyframes ci-cue-in {
            from{opacity:0;transform:translateX(-50%) translateY(8px);}
            to  {opacity:1;transform:translateX(-50%) translateY(0);}
          }
          .ci-cue-label {
            font-family:'Nunito',sans-serif;
            font-size:9px; font-weight:900;
            letter-spacing:0.26em; text-transform:uppercase;
            color:rgba(255,255,255,0.24);
          }
          .ci-cue-arrow {
            width:15px; height:15px;
            border-right:1.5px solid rgba(252,196,40,0.5);
            border-bottom:1.5px solid rgba(252,196,40,0.5);
            transform:rotate(45deg);
            animation:ci-arrow-bob 2s ease-in-out infinite 3s;
          }
          @keyframes ci-arrow-bob {
            0%,100%{transform:rotate(45deg) translate(0,0);   opacity:0.4;}
            50%    {transform:rotate(45deg) translate(3px,3px);opacity:1;}
          }



          /* ──────────── RESPONSIVE PANEL ──────────── */

          /* ── Tablet (640–1023px): 3 columns, keep aspect ratio ── */
          @media (min-width: 640px) and (max-width: 1023px) {
            .ci-panel-wrap { width: 97vw; }
            .ci-col:nth-child(n+4) { display: none; }
            .ci-panel { aspect-ratio: 4 / 3; }
            .ci-sweep-svg { aspect-ratio: 4 / 3; }
            .ci-panel-halo { inset: -40px; }
            .ci-floor-glow { bottom: -35px; height: 60px; }
          }

          /* ── Mobile (< 640px): 3 columns, width pre-computed so zoom lands at 95vw ── */
          @media (max-width: 639px) {
            .ci-panel-wrap { width: ${mobileWrapPx ? mobileWrapPx + "px" : "73vw"}; }
            .ci-panel {
              aspect-ratio: unset !important;
              height: 54vh;
              min-height: 260px;
            }
            .ci-sweep-svg {
              aspect-ratio: unset !important;
              height: 100%;
            }
            /* 3 columns — hide only col 4+ */
            .ci-col:nth-child(n+4) { display: none; }
            /* tight spacing + smaller cells */
            .ci-cols { gap: 2px; padding: 3px; }
            .ci-cell { border-radius: 6px; }
            .ci-cell--rect { aspect-ratio: 2/3; }
            .ci-cell--sq   { aspect-ratio: 1/1; }
            .ci-vig-bot { height: 80px; }
            .ci-chrome { height: 18px; }
            .ci-chrome-pill { width: 36px; }
            .ci-cue { bottom: 10px; }
            .ci-panel-halo { inset: -16px; }
            .ci-floor-glow { bottom: -16px; height: 36px; }
          }

          /* ── Very small (< 380px): 2 columns, same height ── */
          @media (max-width: 379px) {
            .ci-col:nth-child(n+3) { display: none; }
            /* Match the 54vh used in the zoom calculation */
            .ci-panel { height: 54vh; min-height: 260px; }
          }
        `}</style>

        {/* ── DARK BACKGROUND + RANDOMLY SCATTERED/TILTED TOOTHYZ + WHITE FLOOD ── */}
        {/* Base dark background */}
        <div style={{position:"absolute",inset:0,zIndex:0,background:"#01020a",pointerEvents:"none"}}/>
        {/* White flood sits BELOW toothyz so teeth remain visible on white */}
        <div style={{
          position:"absolute", inset:0, zIndex:1,
          background:"white", opacity:0, pointerEvents:"none",
          animation:"ci-white-bg-in 0.85s ease-out 1.25s forwards",
        }}/>
        {/* Randomly placed, randomly tilted toothyz.png — above white flood (zIndex:2) */}
        <div style={{position:"absolute",inset:0,zIndex:2,overflow:"hidden",pointerEvents:"none"}}>
          {[
            {x:3,   y:8,   r:-22, s:28, o:0.48},
            {x:11,  y:31,  r:15,  s:22, o:0.36},
            {x:7,   y:58,  r:-38, s:32, o:0.55},
            {x:4,   y:80,  r:25,  s:24, o:0.40},
            {x:18,  y:14,  r:42,  s:20, o:0.32},
            {x:22,  y:45,  r:-12, s:30, o:0.52},
            {x:16,  y:70,  r:55,  s:26, o:0.36},
            {x:27,  y:91,  r:-30, s:22, o:0.44},
            {x:35,  y:5,   r:18,  s:28, o:0.48},
            {x:38,  y:28,  r:-48, s:24, o:0.32},
            {x:33,  y:55,  r:33,  s:32, o:0.55},
            {x:41,  y:76,  r:-15, s:20, o:0.40},
            {x:48,  y:18,  r:60,  s:26, o:0.36},
            {x:52,  y:40,  r:-25, s:28, o:0.52},
            {x:46,  y:65,  r:40,  s:22, o:0.32},
            {x:55,  y:87,  r:-50, s:30, o:0.48},
            {x:62,  y:10,  r:22,  s:24, o:0.40},
            {x:67,  y:33,  r:-35, s:28, o:0.55},
            {x:60,  y:60,  r:48,  s:20, o:0.36},
            {x:70,  y:82,  r:-18, s:32, o:0.44},
            {x:76,  y:20,  r:30,  s:26, o:0.32},
            {x:80,  y:47,  r:-55, s:24, o:0.52},
            {x:74,  y:72,  r:12,  s:30, o:0.40},
            {x:83,  y:92,  r:-40, s:22, o:0.48},
            {x:88,  y:6,   r:45,  s:28, o:0.36},
            {x:93,  y:26,  r:-20, s:26, o:0.55},
            {x:87,  y:50,  r:35,  s:20, o:0.32},
            {x:91,  y:74,  r:-58, s:32, o:0.44},
            {x:96,  y:40,  r:17,  s:24, o:0.52},
            {x:14,  y:95,  r:-28, s:26, o:0.36},
            {x:57,  y:95,  r:50,  s:22, o:0.40},
            {x:79,  y:95,  r:-15, s:28, o:0.48},
            {x:43,  y:92,  r:38,  s:24, o:0.32},
            {x:25,  y:22,  r:-42, s:30, o:0.44},
            {x:64,  y:48,  r:25,  s:26, o:0.13},
          ].map((t,i) => (
            <img key={i} src={toothyzPng} alt="" style={{
              position:"absolute",
              left:`${t.x}%`, top:`${t.y}%`,
              width:t.s, height:t.s,
              objectFit:"contain",
              transform:`rotate(${t.r}deg)`,
              opacity:t.o,
              pointerEvents:"none",
            }}/>
          ))}
        </div>






        

        {/* WIDE PANEL */}
        <div className="ci-panel-wrap">
          <div className="ci-panel-halo"/>
          <div className="ci-floor-glow"/>



          <div className="ci-panel">


            {/* Chrome */}
            <div className="ci-chrome">
              <div className="ci-chrome-dot" style={{background:"rgba(255,95,87,0.45)"}}/>
              <div className="ci-chrome-dot" style={{background:"rgba(255,189,46,0.45)"}}/>
              <div className="ci-chrome-dot" style={{background:"rgba(40,200,64,0.45)"}}/>
              <div style={{width:14}}/>
              <div className="ci-chrome-pill"/>
              <div className="ci-chrome-bar"/>
              <div className="ci-chrome-dot" style={{background:"rgba(90,120,255,0.22)", width:22, height:18, borderRadius:4}}/>
            </div>

            {/* Overlays */}
            <div className="ci-vig-top"/>
            <div className="ci-vig-bot"/>
            <div className="ci-vig-l"/>
            <div className="ci-vig-r"/>

            {/* 4-column scroll grid */}
            <div className="ci-grid-outer">
              <div className="ci-cols">
                {charCols.map((col, ci) => (
                  <div key={ci} className="ci-col">
                    <div className="ci-col-inner">
                      {col.map((item, i) => (
                        <div key={i} className={`ci-cell ci-cell--${item.size}`}>
                          <img src={item.src} alt="" loading="lazy"/>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Two white lines sweeping clockwise around the panel */}
          <svg className="ci-sweep-svg" viewBox="0 0 1000 580"
            preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <filter id="ci-sweep-glow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="5" result="blur"/>
                <feMerge>
                  <feMergeNode in="blur"/>
                  <feMergeNode in="blur"/>
                  <feMergeNode in="SourceGraphic"/>
                </feMerge>
              </filter>
            </defs>
            <rect x="3" y="3" width="994" height="574"
              rx="18" ry="18"
              className="ci-sweep-line"
              filter="url(#ci-sweep-glow)"/>
          </svg>

          <div className="ci-reflect"/>
        </div>

        {/* Scroll cue */}
        <div className="ci-cue">
          <span className="ci-cue-label">Scroll to Shop</span>
          <div className="ci-cue-arrow"/>
        </div>
      </section>
      {/* ═══════════════ END CINEMATIC PREVIEW ═══════════════ */}


      {/* ── CART — PrimeReact Dialog ── */}
      <style>{`
        .cart-dialog.p-dialog {
          background: #ffffff !important;
          border-radius: 0 !important;
          box-shadow: -8px 0 40px rgba(0,0,0,0.25) !important;
          border: none !important;
          margin: 0 !important;
          width: min(420px, 100vw) !important;
          height: 100vh !important;
          max-height: 100vh !important;
          position: fixed !important;
          top: 0 !important; right: 0 !important;
          display: flex !important; flex-direction: column !important;
        }
        .p-dialog-mask.cart-dialog-mask {
          justify-content: flex-end !important;
          align-items: stretch !important;
          backdrop-filter: blur(4px) !important;
          background: rgba(0,0,0,0.55) !important;
        }
        .cart-dialog .p-dialog-header {
          background: #ffffff !important;
          border-bottom: 1px solid #e5e7eb !important;
          padding: 20px 24px !important;
          flex-shrink: 0 !important;
          border-radius: 0 !important;
        }
        .cart-dialog .p-dialog-header-icons .p-dialog-header-close {
          background: #f3f4f6 !important;
          color: #374151 !important;
          border-radius: 50% !important;
          width: 32px !important; height: 32px !important;
          transition: all 0.2s ease !important;
        }
        .cart-dialog .p-dialog-header-icons .p-dialog-header-close:hover {
          background: #111 !important; color: #fff !important;
        }
        .cart-dialog .p-dialog-content {
          background: #ffffff !important;
          padding: 0 !important; flex: 1 !important;
          display: flex !important; flex-direction: column !important;
          overflow: hidden !important; border-radius: 0 !important;
        }
        @keyframes cart-slide-in {
          from { transform: translateX(100%); opacity: 0.5; }
          to   { transform: translateX(0);    opacity: 1; }
        }
        .cart-dialog.p-dialog {
          animation: cart-slide-in 0.28s cubic-bezier(0.22, 1, 0.36, 1) both !important;
        }
      `}</style>

      <Dialog
        visible={isCartOpen}
        onHide={() => setIsCartOpen(false)}
        header={cartHeader}
        className="cart-dialog"
        maskClassName="cart-dialog-mask"
        modal dismissableMask blockScroll closable
        draggable={false} resizable={false} position="right"
      >
        <div style={{ flex:1, overflowY:"auto", padding:"16px 24px", display:"flex", flexDirection:"column", gap:12 }}>
          {cart.length === 0 ? (
            <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:12, color:"#9ca3af", paddingTop:80 }}>
              <span style={{ fontSize:"3rem" }}>🛍️</span>
              <p style={{ fontWeight:600, fontSize:"1rem" }}>Your bag is empty!</p>
            </div>
          ) : (
            cart.map((item) => (
              <div key={item.variantId} style={{ display:"flex", gap:12, padding:"12px", borderRadius:16, background:"#f9fafb", border:"1px solid #f3f4f6", alignItems:"center" }}>
                {item.image && <img src={item.image} style={{ width:56, height:56, borderRadius:12, objectFit:"cover", flexShrink:0 }} alt={item.title}/>}
                <div style={{ flex:1, minWidth:0 }}>
                  <p style={{ fontWeight:700, fontSize:"0.85rem", color:"#111", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{item.title}</p>
                  <p style={{ fontSize:"0.75rem", color:"#9ca3af", marginTop:2 }}>{formatPrice(item.price, item.currencyCode)} each</p>
                  <p style={{ fontSize:"0.85rem", fontWeight:900, color:T.gold, marginTop:2 }}>{formatPrice(parseFloat(item.price)*item.quantity, item.currencyCode)}</p>
                </div>
                <div style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}>
                  <button onClick={()=>updateQuantity(item.variantId,-1)} style={{ width:32, height:32, borderRadius:"50%", border:"none", background:"#e5e7eb", color:"#374151", fontWeight:900, fontSize:"1.1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>−</button>
                  <span style={{ width:24, textAlign:"center", fontWeight:900, color:"#111", fontSize:"0.9rem" }}>{item.quantity}</span>
                  <button onClick={()=>updateQuantity(item.variantId,1)} style={{ width:32, height:32, borderRadius:"50%", border:"none", background:T.cyan, color:"#fff", fontWeight:900, fontSize:"1.1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>+</button>
                </div>
              </div>
            ))
          )}
        </div>
        {cart.length > 0 && (
          <div style={{ flexShrink:0, padding:"16px 24px", borderTop:"1px solid #e5e7eb", display:"flex", flexDirection:"column", gap:12, background:"#fff" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span style={{ color:"#6b7280", fontSize:"0.9rem" }}>Subtotal</span>
              <span style={{ fontWeight:900, fontSize:"1.2rem", color:"#111" }}>{formatPrice(cartTotal, cart[0]?.currencyCode)}</span>
            </div>
            <button onClick={handleCheckout} disabled={isCheckingOut}
              style={{ width:"100%", padding:"14px", borderRadius:16, border:"none", background:`linear-gradient(135deg,${T.gold},${T.goldLight})`, color:"#000", fontFamily:"'Bubblegum Sans',cursive", fontWeight:900, fontSize:"1.1rem", cursor:"pointer", opacity:isCheckingOut?0.6:1, transition:"all 0.15s" }}>
              {isCheckingOut ? "Processing..." : "Checkout Now 🛍️"}
            </button>
          </div>
        )}
      </Dialog>


      {/* ── Shop Hero ── */}
      <section className="relative overflow-hidden" style={{ minHeight:"100vh", backgroundColor:"#00081d", backgroundImage:`url('${shopBackground}')`, backgroundSize:"100% auto", backgroundPosition:"center calc(100%)", backgroundRepeat:"no-repeat" }}>
        <style>{`
          .shop-hero-overlay{background:linear-gradient(105deg,rgba(0,4,20,0.97) 0%,rgba(0,4,20,0.82) 30%,rgba(0,4,20,0.5) 60%,rgba(0,4,20,0.75) 85%,rgba(0,4,20,0.96) 100%);}
          @keyframes shop-panel-in{from{opacity:0;transform:translateX(48px) scale(0.94)}to{opacity:1;transform:translateX(0) scale(1)}}
          .shop-panel-in{animation:shop-panel-in 0.75s cubic-bezier(0.34,1.56,0.64,1) 0.3s both;}
          @keyframes shop-title-stamp{from{opacity:0;transform:scale(1.12);filter:blur(6px)}to{opacity:1;transform:scale(1);filter:blur(0)}}
          .shop-title-stamp{animation:shop-title-stamp 0.7s cubic-bezier(0.22,1,0.36,1) 0.1s both;}
          .shop-side-rail{writing-mode:vertical-rl;text-orientation:mixed;transform:rotate(180deg);}
          @keyframes shop-badge-pulse{0%,100%{box-shadow:0 0 0 0 rgba(252,211,77,0.45)}50%{box-shadow:0 0 0 10px rgba(252,211,77,0)}}
          .shop-badge-pulse{animation:shop-badge-pulse 2.2s ease-in-out infinite;}
          .shop-perks-row{display:flex;gap:0;border:1px solid rgba(252,211,77,0.25);border-radius:14px;overflow:hidden;}
          .shop-perk-cell{flex:1;padding:12px 10px;text-align:center;border-right:1px solid rgba(252,211,77,0.15);backdrop-filter:blur(8px);background:rgba(12,30,58,0.55);transition:background 0.2s;}
          .shop-perk-cell:last-child{border-right:none;}
          .shop-perk-cell:hover{background:rgba(245,158,11,0.1);}
          @media(min-width:768px){.shop-hero-inner{display:grid;grid-template-columns:52px 1fr 1fr auto;min-height:100vh}.shop-rail,.shop-panel{display:flex!important}}
          @media(max-width:767px){.shop-hero-inner{display:flex;flex-direction:column;padding:100px 20px 40px}.shop-rail{display:none!important}.shop-panel{display:flex!important;justify-content:center;margin-top:24px}.shop-panel>div{width:100%!important;max-width:380px!important}}
          .shop-gif-carousel { width:100%; }
          .shop-gif-carousel .p-carousel { background: transparent !important; }
          .shop-gif-carousel .p-carousel-container { background: transparent !important; }
          .shop-gif-carousel .p-carousel-items-content { background: transparent !important; }
          .shop-gif-carousel .p-carousel-items-container { background: transparent !important; }
          .shop-gif-carousel .p-carousel-content { background: transparent !important; }
          .shop-gif-carousel .p-carousel-prev,
          .shop-gif-carousel .p-carousel-next { color: rgba(252,211,77,0.8) !important; background: rgba(12,30,58,0.6) !important; border: 1px solid rgba(252,211,77,0.35) !important; border-radius: 50% !important; width: 36px !important; height: 36px !important; flex-shrink:0; }
          .shop-gif-carousel .p-carousel-prev:hover,
          .shop-gif-carousel .p-carousel-next:hover { background: rgba(245,158,11,0.3) !important; }
          .shop-gif-carousel .p-carousel-indicators { display:flex; gap:8px; justify-content:center; padding-top:14px; }
          .shop-gif-carousel .p-carousel-indicator button { width:8px !important; height:8px !important; border-radius:50% !important; background:rgba(252,211,77,0.3) !important; border:none !important; transition:background 0.2s; }
          .shop-gif-carousel .p-carousel-indicator.p-highlight button { background:rgba(252,211,77,1) !important; }
        `}</style>

        <div className="shop-hero-overlay absolute inset-0 pointer-events-none" style={{zIndex:1}}/>
        <div className="shop-hero-inner relative z-10">

          <div className="shop-rail flex-col items-center justify-between py-32 pl-3" style={{borderRight:"1px solid rgba(252,211,77,0.1)"}}>
            <span className="shop-side-rail" style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.62rem",fontWeight:900,letterSpacing:"0.28em",textTransform:"uppercase",color:"rgba(252,211,77,0.5)"}}>Toothyz · Official Store</span>
            <div style={{width:1,flex:1,background:"linear-gradient(to bottom,transparent,rgba(252,211,77,0.25),transparent)",margin:"12px 0"}}/>
            <span className="shop-side-rail" style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.62rem",fontWeight:900,letterSpacing:"0.28em",textTransform:"uppercase",color:"rgba(252,211,77,0.35)"}}>A15HAQ LTD · SC650199</span>
          </div>

          <div className="relative flex flex-col justify-center px-8 md:px-16 py-32">
            <div className="flex items-center gap-3 mb-6 shop-title-stamp">
              <div style={{height:1,width:40,background:`linear-gradient(to right,transparent,${T.goldLight})`}}/>
              <span style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.72rem",fontWeight:900,letterSpacing:"0.22em",textTransform:"uppercase",color:T.goldLight}}>Now Open</span>
              <div style={{height:1,width:40,background:`linear-gradient(to left,transparent,${T.goldLight})`}}/>
            </div>
            <h1 className="shop-title-stamp" style={{fontFamily:"'Bubblegum Sans',cursive",fontSize:"clamp(3.5rem,9vw,7.5rem)",fontWeight:900,lineHeight:0.88,textShadow:"0 4px 48px rgba(0,0,0,0.9)",maxWidth:600}}>
              <span style={{color:"#ffffff",display:"block"}}>Shop</span>
              <span style={{background:`linear-gradient(135deg,${T.goldLight},${T.gold},${T.cyanGlow},${T.goldLight})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",display:"block",backgroundSize:"200% auto",animation:"shimmer-move 4s linear infinite"}}>Toothyz</span>
              <span style={{color:"rgba(255,255,255,0.7)",display:"block",fontSize:"0.52em",letterSpacing:"0.02em"}}>Plush · Collectible</span>
            </h1>
            <div className="shop-perks-row mt-10 shop-panel-in" style={{maxWidth:480,animationDelay:"0.55s"}}>
              {[{icon:"🚀",label:"Fast Dispatch"},{icon:"🎁",label:"Gift-Ready"},{icon:"🎨",label:"Quality Assured"}].map((p,i)=>(
                <div key={i} className="shop-perk-cell">
                  <div style={{fontSize:"1.4rem",marginBottom:4}}>{p.icon}</div>
                  <div style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.65rem",fontWeight:900,color:"rgba(255,255,255,0.75)",letterSpacing:"0.05em",textTransform:"uppercase"}}>{p.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Intro GIF Carousel ── */}
          <div style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            padding:"clamp(16px,4vw,80px) clamp(8px,2vw,24px)",
            width:"100%",
          }}>
            <div className="shop-gif-carousel" style={{width:"100%",maxWidth:600}}>
              <Carousel
                value={[INTRO_GIF, package1, package2]}
                numVisible={1}
                numScroll={1}
                autoplayInterval={2500}
                circular
                itemTemplate={(src) => (
                  <div style={{
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    width:"100%",
                    padding:"0 8px",
                  }}>
                    <img
                      src={src}
                      alt="Toothyz plush"
                      style={{
                        width:"100%",
                        height:"clamp(260px,35vw,500px)",
                        objectFit:"contain",
                        borderRadius:24,
                        filter:"none",
                        background:"transparent",
                        display:"block",
                        margin:"0 auto",
                      }}
                    />
                  </div>
                )}
              />
            </div>
          </div>

          <div className="shop-panel items-center justify-center pr-0 md:pr-16 py-0 md:py-32 shop-panel-in">
            <div style={{width:"clamp(220px,22vw,290px)",background:"linear-gradient(145deg,rgba(12,30,58,0.92),rgba(19,41,82,0.88))",border:`1.5px solid ${T.goldLight}40`,borderRadius:28,padding:"32px 24px",backdropFilter:"blur(20px)",boxShadow:`0 0 60px ${T.gold}18,0 24px 64px rgba(0,0,0,0.7)`,display:"flex",flexDirection:"column",alignItems:"center",gap:20,textAlign:"center",position:"relative"}}>
              <div className="shop-badge-pulse inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full" style={{background:`${T.gold}20`,border:`1px solid ${T.goldLight}60`}}>
                <span style={{width:6,height:6,borderRadius:"50%",background:T.goldLight,display:"inline-block"}}/>
                <span style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.65rem",fontWeight:900,color:T.goldLight}}>New Drops</span>
              </div>
              <img src={shoppingGif} width={500} alt="shopping mascot"/>
              <div>
                <div style={{fontFamily:"'Bubblegum Sans',cursive",fontSize:"2.8rem",fontWeight:900,color:T.goldLight}}>{products.length||'20'}+</div>
                <div style={{fontFamily:"'Nunito',sans-serif",fontSize:"0.72rem",fontWeight:900,color:"rgba(255,255,255,0.65)"}}>Plushies Available</div>
              </div>
              <button onClick={()=>document.getElementById("shop-store")?.scrollIntoView({behavior:"smooth"})} className="w-full rounded-xl py-3 font-black transition-all hover:brightness-110 active:scale-95" style={{fontFamily:"'Bubblegum Sans',cursive",background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,color:"#040D1A"}}>
                Browse the Shop 🛒
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* ── Store Content ── */}
      <section id="shop-store" style={{background:T.dark?T.bgPage:T.sectionAlt,paddingTop:80,paddingBottom:80}}>
        <div className="max-w-6xl mx-auto px-5">
          <SectionHead eyebrow="The Collection" title="Shop Toothyz" sub="Select a friend to take home. Secure checkout via Shopify."/>

          {loading ? (
            <div className="py-32 text-center">
              <KawaiiTooth size={48} className="mx-auto mb-4 plush-bob"/>
              <p className="font-bold opacity-50" style={{color:T.textHead}}>Summoning Toothyz...</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
              {products.map((product) => {
                const variant = product.variants[0];
                const cartItem = getCartItem(variant.id);
                const inCart = !!cartItem;
                return (
                  <div key={product.id} className="group relative rounded-[32px] p-6 transition-all hover:-translate-y-2"
                    style={{background:T.bgCard,border:`1px solid ${T.cyan}15`,boxShadow:T.shadowSm}}>
                    {inCart && (
                      <div className="absolute top-4 right-4 w-7 h-7 rounded-full flex items-center justify-center text-xs font-black text-black shadow z-10" style={{background:T.gold}}>
                        {cartItem.quantity}
                      </div>
                    )}
                    <div className="aspect-square rounded-2xl mb-5 overflow-hidden bg-black/20 flex items-center justify-center p-6">
                      <img src={product.images[0]?.src} alt={product.title} className="max-h-full object-contain transition-transform group-hover:scale-110"/>
                    </div>
                    <h3 className="text-xl font-black mb-1" style={{fontFamily:"'Bubblegum Sans',cursive",color:T.textHead}}>{product.title}</h3>
                    <p className="text-lg font-black mb-5" style={{color:T.gold}}>{formatPrice(variant.price.amount, variant.price.currencyCode)}</p>
                    <div style={{display:"flex",gap:8,marginBottom:8}}>
                      <button onClick={()=>setDetailProduct(product)} className="flex-1 py-3 rounded-2xl font-black transition-all active:scale-95 text-sm"
                        style={{background:T.bgCardHi,border:`1.5px solid ${T.cyan}40`,color:T.cyan,fontFamily:"'Bubblegum Sans',cursive"}}>
                        Details 🔍
                      </button>
                    </div>
                    {!variant.available ? (
                      <button disabled className="w-full py-4 rounded-2xl font-black" style={{background:"#F1F5F9",color:"#94A3B8",fontFamily:"'Bubblegum Sans',cursive",cursor:"not-allowed",border:"1.5px solid #E2E8F0"}}>😢 Out of Stock</button>
                    ) : inCart ? (
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-2 flex-1 rounded-2xl px-3 py-2 justify-between" style={{background:`${T.cyan}20`,border:`1.5px solid ${T.cyan}40`}}>
                          <button onClick={()=>updateQuantity(variant.id,-1)} className="w-8 h-8 rounded-full bg-white/80 hover:bg-white text-gray-800 font-black text-lg flex items-center justify-center transition-colors">−</button>
                          <span className="font-black text-sm" style={{color:T.textHead}}>{cartItem.quantity} in cart</span>
                          <button onClick={()=>addToCart(product)} className="w-8 h-8 rounded-full text-white font-black text-lg flex items-center justify-center transition-colors" style={{background:T.cyan}}>+</button>
                        </div>
                        <button onClick={()=>setIsCartOpen(true)} className="px-3 py-2 rounded-2xl font-black text-sm transition-all active:scale-95"
                          style={{background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,color:"#000",fontFamily:"'Bubblegum Sans',cursive"}}>View 🛒</button>
                      </div>
                    ) : (
                      <button onClick={()=>addToCart(product)} className="w-full py-4 rounded-2xl font-black transition-all active:scale-95"
                        style={{background:`linear-gradient(135deg,${T.cyan},${T.cyanBright})`,color:"#00081d",fontFamily:"'Bubblegum Sans',cursive",boxShadow:`0 8px 20px ${T.cyan}30`}}>
                        Adopt Me 🛒
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              {icon:"🚀",title:"Fast Dispatch",desc:"Orders packed within 2 business days.",c:T.cyan},
              {icon:"🎁",title:"Gift Packaging",desc:"Ships in a signature gift-ready box.",c:T.goldLight},
              {icon:"💎",title:"Premium Detail",desc:"Hand-finished quality in every stitch.",c:T.indigo},
            ].map((f,i)=>(
              <div key={i} className="rounded-3xl p-7 text-center" style={{background:T.bgCard,border:`1.5px solid ${f.c}20`}}>
                <div className="text-4xl mb-3">{f.icon}</div>
                <h3 className="font-black text-base mb-1" style={{fontFamily:"'Bubblegum Sans',cursive",color:f.c}}>{f.title}</h3>
                <p className="text-xs opacity-70" style={{color:T.textBody}}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer setPage={setPage}/>

      {detailProduct && (
        <ProductDetailDialog
          product={detailProduct}
          onClose={() => setDetailProduct(null)}
          onAddToCart={addToCart}
          cartItem={getCartItem(detailProduct.variants[0].id)}
          onUpdateQuantity={updateQuantity}
        />
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════
//  DATA
// ═══════════════════════════════════════════════════════
const CHAR_DATA = [
  {name:"Wizzy",   theme:"The Wizard",       desc:"Brown hair, round specs, and a Gryffindor scarf, this plush tooth arrived at Toothyz Academy fully enrolled and totally ready for magic.",  color:"#F59E0B",accent:"#FCD34D",emoji:"🧙",tag:"Fan Fave",  cat:"Pop Culture", charimg:wizardImage,    lore:"Legend says Wizzy arrived fully formed on a stormy night, scarf flapping, specs slightly crooked, which he insists is on purpose. His brown embroidered hair, round glasses, and Gryffindor-stripe scarf suggest he attended a very particular wizarding school, but he won't confirm or deny. He simply says 'the magic is in the felt.'"},
  {name:"Batsy",   theme:"The Dark Knight",  desc:"Cape on, cowl stitched, bat-signal embroidered on the belt. This tooth is Gotham's most huggable protector, and he knows it.",              color:"#94A3B8",accent:"#CBD5E1",emoji:"🦇",tag:"Bestseller",cat:"Pop Culture", charimg:darkKnightImage, lore:"By day: an unassuming plush on a shelf. By night: the protector of the toy box. Batsy's embroidered cowl and yellow bat-signal belt buckle are not for decoration, they're operational. His little red smile stitching is the most disarming thing about him."},
  {name:"Shroomy", theme:"The Power-Up",     desc:"Straight out of the Mushroom Kingdom, red cap, white spots, and a Mario-print scarf. One touch and you gain an extra life.",               color:"#F87171",accent:"#FCA5A5",emoji:"🍄",tag:"Limited",   cat:"Gaming",     charimg:shroomyImage,   lore:"Shroomy gives you +1 life, +1 happiness, and +1 reason to smile every morning. He appeared in the Mushroom Kingdom and immediately demanded a tooth-shaped body. His embroidered Mario-print scarf took six attempts. He was patient. Collectors are not."},
  {name:"Hexie",   theme:"The Witch",        desc:"Round spectacle stitching, a red-and-gold HP scarf, and a pointy black hat with a gold band. She arrived one stormy night and never left.", color:"#C084FC",accent:"#E9D5FF",emoji:"🔮",tag:"Magical",   cat:"Fantasy",    charimg:witchImage,     lore:"No one made Hexie, she appeared, already embroidered, sitting on a table with a pointy black hat and a red-and-gold HP scarf. Her round spectacle stitching sees things others miss. She is the oldest and wisest Toothyz, and her hat has definitely had adventures it hasn't told anyone about."},
];

const ALL_CHARS = [
  ...CHAR_DATA,
  {name:"Flashy",  theme:"The Speedster",    desc:"All-red suit, yellow lightning bolt, and a tiny cape that never stops fluttering. The fastest tooth in the Toothyz universe, blink and you'll miss it.", color:"#EF4444",accent:"#FCA5A5",emoji:"⚡",tag:"Bestseller",cat:"Pop Culture", charimg:flashImage, lore:"Flashy stitched himself in under three seconds, or so he claims. His all-red felt suit with the gold lightning emblem on the belt is just slow enough to be huggable. Every other Toothyz blinked and he was already on the shelf, smiling."},
  {name:"Frostie", theme:"The Ice Queen",    desc:"White plush tooth wrapped in a teal cape trimmed with faux fur, a glittery tiara, and a snowflake charm. Cool to the touch, warm to the heart.", color:"#BAE6FD",accent:"#E0F2FE",emoji:"❄️",tag:"Limited Edition",  cat:"Fantasy",    charimg:frostieImage, lore:"Frostie arrived mid-winter, trailing glitter and frost. Nobody knows where she came from but the toy box has been 3 degrees cooler ever since. She doesn't melt. She just judges."},
  {name:"Spidey",  theme:"The Web-Slinger",  desc:"Red-and-blue plush with web stitching and white eyes embroidered right on the tooth. Your friendly neighbourhood Toothyz.",                          color:"#DC2626",accent:"#FECACA",emoji:"🕷️",tag:"New Drop",  cat:"Pop Culture", charimg:spideyImage, lore:"Spidey swung into the Toothyz universe one rainy night, stuck to the ceiling of the workshop and refused to come down until properly embroidered. His web stitching took three attempts. Worth it."},
  {name:"Greenie", theme:"The TMNT",         desc:"Green felt tooth with a blue ninja mask, big embroidered eyes, and a cheeky belt. Cowabunga, dental hygiene has never been this heroic.",           color:"#4ADE80",accent:"#BBF7D0",emoji:"🐢",tag:"Original",  cat:"Pop Culture", charimg:greenieImage, lore:"Greenie practices his nunchuck moves in the toy box at 3am. The other Toothyz pretend not to hear him. His blue mask is slightly crooked but he says that's intentional. The belt buckle says otherwise."},
  {name:"Hulky",   theme:"The Smash",        desc:"Angry green tooth with a scowling embroidered face, wild black hair, and furrowed brows. You won't like him when he has a cavity.",                  color:"#22C55E",accent:"#86EFAC",emoji:"💚",tag:"Fan Fave",  cat:"Pop Culture", charimg:hulkyImage, lore:"Hulky was made on a Monday. That explains everything. His brows were embroidered in a permanent scowl but collectors report that if you squeeze him hard enough, the scowl softens by exactly 0.3%. Progress."},
  {name:"Molar-io",   theme:"The Plumber",      desc:"Red 'M' cap, blue overalls, a round nose, and the most iconic moustache in plush history. It's-a him, the Toothyz everyone wants to collect.",     color:"#EF4444",accent:"#FCA5A5",emoji:"🍄",tag:"Bestseller",cat:"Gaming",      charimg:marioImage, lore:"Every Toothyz workshop needs a plumber. Molar-io showed up, unclogged three sinks, and then demanded to be made into a plush. The moustache alone took two hours. It-sa him. It really is."},
  {name:"Dino",    theme:"The Dino",         desc:"Bright green plush tooth with a curly dino tail, spine fins, and the goofiest smile you've ever seen embroidered on felt. RAWR.",                    color:"#86EFAC",accent:"#DCFCE7",emoji:"🦕",tag:"New Drop",  cat:"Fantasy",    charimg:dinoImage, lore:"Dino was supposed to be a limited edition but refused to go extinct a second time. His tail curls up when he's happy and his spine fins crackle when it's about to rain. Scientists are baffled. Collectors are delighted."},
  {name:"Winnie",  theme:"The Silly Old Bear",desc:"Golden plush tooth with round bear ears, embroidered pot-of-honey eyes, and a little red shirt stripe. Oh bother, this one's too cute.",         color:"#F59E0B",accent:"#FDE68A",emoji:"🍯",tag:"Fan Fave",  cat:"Pop Culture", charimg:winnieImage, lore:"Winnie was found sitting in a corner of the workshop staring at an empty honey jar. He was immediately embroidered with the most expressive bear eyes possible. Oh bother indeed, now everyone wants one."},
  {name:"Stormy",  theme:"The Tooth Fairy",  desc:"All-white plush crowned with glittery gold wings, a sparkly tiara, and a magic wand. The most legendary tooth fairy, because she IS a tooth.",    color:"#E9D5FF",accent:"#F3E8FF",emoji:"🧚",tag:"Magical",   cat:"Fantasy",    charimg:stormyImage, lore:"Stormy is the original. The legend. Every lost tooth that has ever found a coin under a pillow, she organised that. She is now in semi-retirement as a plush and she absolutely loves it."},
  {name:"Minnie",  theme:"The Constructor",  desc:"White plush tooth in a hard hat and work belt, clutching a tiny mallet. Building healthy smiles one brick at a time.",                              color:"#F59E0B",accent:"#FDE68A",emoji:"🔨",tag:"New Drop",  cat:"Originals",  charimg:minnieImage, lore:"Minnie built the shelf she now sits on. The mallet is real (in spirit). Her hard hat is embroidered to tilt at exactly 12 degrees, that's the angle of confidence, she says. The toolbelt has six pockets and all of them are full."},
  {name:"Kitty",   theme:"The Rainbow Cat",  desc:"Embroidered cat face on felt with a pastel nose, whiskers, and an explosion of rainbow ribbon tulle. This is the most extra hair clip in existence.", color:"#38BDF8",accent:"#BAE6FD",emoji:"🌈",tag:"Limited Edition",   cat:"Accessories", charimg:kittyImage,  lore:"Kitty arrived as a hair clip and immediately declared herself the main character. The rainbow tulle was her idea. The whiskers were negotiated at length. She now has a fanbase of 4-year-olds who refuse to wear any other clip."},
  {name:"Crystella", theme:"The Crystal Queen", desc:"Encrusted head-to-toe in rose-pink rhinestones with butterfly wings of clear crystal and a golden crown. The most dazzling tooth in the entire Toothyz universe.", color:"#F472B6",accent:"#FBCFE8",emoji:"💎",tag:"Limited Edition", cat:"Crystal Series", charimg:crystallaImage, lore:"Crystella didn't arrive, she materialised. One moment the shelf was empty; the next, she was there — glittering, crowned, and completely unbothered. Every pink rhinestone was placed by hand, and her butterfly crystal wings catch the light from three rooms away. She has already decided she is the rarest one. No one has argued."},
  {name:"Prismie",   theme:"The Ice Fairy",    desc:"Draped in shimmering white aurora crystals with silver wings, a golden crown, and a permanent smile that says 'I know something you don't.'", color:"#E0F2FE",accent:"#F0F9FF",emoji:"🌟",tag:"Limited Edition", cat:"Crystal Series", charimg:prismieImage,  lore:"Prismie is made entirely of wishes and iridescent crystal. Her white aurora rhinestones shift colour depending on the light, and no one agrees on what colour she actually is. Silver? Pearl? Pure magic? She smiles when you ask. She will not clarify. Her golden crown was the last thing added, and somehow it made everything make sense."},
  {name:"Goldie",    theme:"The Rose Gold Royale", desc:"Covered in clear and sapphire crystals with champagne-rose gold wings and a matching crown. Regal, radiant, and fully aware of it.", color:"#FB923C",accent:"#FED7AA",emoji:"👑",tag:"Limited Edition", cat:"Crystal Series", charimg:goldieImage,   lore:"Goldie was made for royalty and immediately became royalty. Her sapphire-flecked crystal face, rose gold champagne wings, and matching crown create a shimmer that has caused several minor accidents from people stopping to stare. She sits slightly higher than the other Toothyz. Nobody put her there. She just is."},
];

const LORE = [
  {name:"Wizzy",  tag:"Pop Culture",color:"#F59E0B",icon:"🧙", charimg:wizardImage,
    story:"Legend says Wizzy arrived fully formed on a stormy night, scarf flapping, specs slightly crooked, which he insists is on purpose. His brown embroidered hair, round glasses, and Gryffindor-stripe scarf suggest he attended a very particular wizarding school, but he won't confirm or deny. He simply says 'the magic is in the felt.'"},
  {name:"Batsy",  tag:"Pop Culture",color:"#64748B",icon:"🦇", charimg:darkKnightImage,
    story:"By day: an unassuming plush on a shelf. By night: the protector of the toy box. Batsy's embroidered cowl and yellow bat-signal belt buckle are not for decoration, they're operational. His little red smile stitching is the most disarming thing about him."},
  {name:"Flashy", tag:"Pop Culture",color:"#EF4444",icon:"⚡", charimg:flashImage,
    story:"Flashy stitched himself in under three seconds, or so he claims. His all-red felt suit with the gold lightning emblem on the belt is just slow enough to be huggable. Every other Toothyz blinked and he was already on the shelf, smiling."},
  {name:"Hexie",  tag:"Fantasy",    color:"#C084FC",icon:"🔮", charimg:witchImage,
    story:"No one made Hexie, she appeared, already embroidered, sitting on a table with a pointy black hat and a red-and-gold HP scarf. Her round spectacle stitching sees things others miss. She is the oldest and wisest Toothyz, and her hat has definitely had adventures it hasn't told anyone about."},
  {name:"Crystella", tag:"Crystal Series", color:"#F472B6", icon:"💎", charimg:crystallaImage,
    story:"Crystella didn't arrive, she materialised. One moment the shelf was empty; the next, she was there — glittering, crowned, and completely unbothered. Every pink rhinestone was placed by hand, and her butterfly crystal wings catch the light from three rooms away. She has already decided she is the rarest one. No one has argued."},
  {name:"Prismie",   tag:"Crystal Series", color:"#BAE6FD", icon:"🌟", charimg:prismieImage,
    story:"Prismie is made entirely of wishes and iridescent crystal. Her white aurora rhinestones shift colour depending on the light, and no one agrees on what colour she actually is. Silver? Pearl? Pure magic? She smiles when you ask. She will not clarify. Her golden crown was the last thing added, and somehow it made everything make sense."},
  {name:"Goldie",    tag:"Crystal Series", color:"#FB923C", icon:"👑", charimg:goldieImage,
    story:"Goldie was made for royalty and immediately became royalty. Her sapphire-flecked crystal face, rose gold champagne wings, and matching crown create a shimmer that has caused several minor accidents from people stopping to stare. She sits slightly higher than the other Toothyz. Nobody put her there. She just is."},
];

// ── Loading Screen ────────────────────────────────────
// ── Loading Screen ────────────────────────────────────
const LoadingScreen = ({ onDone, onDissolveStart, progress = 0 }) => {
  const canvasRef = useRef(null);
  const gifRef    = useRef(null);
  const hasStartedRef = useRef(false);
  const progressRef   = useRef(0);
  const smoothRef     = useRef(0); // ← smoothed display value

  useEffect(() => {
    progressRef.current = progress;
  }, [progress]);

  useEffect(() => {
    if (hasStartedRef.current) return;
    hasStartedRef.current = true;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    const dpr = window.devicePixelRatio || 1;
    const W = window.innerWidth;
    const H = window.innerHeight;
    canvas.width  = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width  = `${W}px`;
    canvas.style.height = `${H}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    let phase = "gathering";
    let rafId;

    const PX           = 10 * dpr;
    const BLOCKS_FRAME = W < 768 ? 100 : 220;
    let dissolveSnap, blockOrder, blockCursor, blockCols;

    const initDissolve = () => {
      dissolveSnap = ctx.getImageData(0, 0, W * dpr, H * dpr);
      blockCols = Math.ceil(W * dpr / PX);
      const blockRows = Math.ceil(H * dpr / PX);
      const total = blockCols * blockRows;
      blockOrder = new Uint32Array(total);
      for (let i = 0; i < total; i++) blockOrder[i] = i;
      for (let i = total - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [blockOrder[i], blockOrder[j]] = [blockOrder[j], blockOrder[i]];
      }
      blockCursor = 0;
    };

    const cx = W / 2;
    const cy = H / 2;

    const drawBackground = () => {
      const grad = ctx.createRadialGradient(cx, cy * 0.6, 0, cx, cy * 0.6, Math.max(W, H) * 0.8);
      grad.addColorStop(0,   "#0a1f40");
      grad.addColorStop(0.6, "#040D1A");
      grad.addColorStop(1,   "#020810");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, W, H);
    };

    const drawStars = (t) => {
      [
        { x: W*0.10, y: H*0.15, s: 18, d: 0,   c: "#38BDF8" },
        { x: W*0.85, y: H*0.10, s: 14, d: 0.4, c: "#FCD34D" },
        { x: W*0.05, y: H*0.70, s: 12, d: 0.8, c: "#F9A8D4" },
        { x: W*0.92, y: H*0.65, s: 16, d: 0.3, c: "#7DD3FC" },
      ].forEach(({ x, y, s, d, c }) => {
        const alpha = 0.4 + 0.6 * (0.5 + 0.5 * Math.sin((t / 1000 + d) * Math.PI));
        ctx.save();
        ctx.globalAlpha = alpha * 0.7;
        ctx.fillStyle = c;
        ctx.translate(x, y);
        ctx.beginPath();
        for (let i = 0; i < 8; i++) {
          const angle  = (i * Math.PI) / 4;
          const radius = i % 2 === 0 ? s / 2 : s / 5;
          i === 0
            ? ctx.moveTo(Math.cos(angle) * radius, Math.sin(angle) * radius)
            : ctx.lineTo(Math.cos(angle) * radius, Math.sin(angle) * radius);
        }
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      });
    };

    const animate = (ts) => {
      ctx.clearRect(0, 0, W, H);

      // ── GATHERING ──
      if (phase === "gathering") {
        drawBackground();
        drawStars(ts);

        // Lerp smoothed value toward real progress each frame
        const target = Math.min(Math.max(progressRef.current, 0), 1);
        smoothRef.current += (target - smoothRef.current) * 0.045;
        // Snap to 1 when close enough so we don't stall forever
        if (target >= 1 && smoothRef.current > 0.995) smoothRef.current = 1;
        const load = smoothRef.current;

        const bw = 180, bh = 5;
        const bx = cx - bw / 2, by = cy + 160;
        ctx.fillStyle = "rgba(56,189,248,0.15)";
        ctx.beginPath(); ctx.roundRect(bx, by, bw, bh, 10); ctx.fill();
        const grad = ctx.createLinearGradient(bx, 0, bx + bw, 0);
        grad.addColorStop(0,   "#0EA5E9");
        grad.addColorStop(0.5, "#38BDF8");
        grad.addColorStop(1,   "#7DD3FC");
        ctx.fillStyle = grad;
        ctx.beginPath(); ctx.roundRect(bx, by, bw * load, bh, 10); ctx.fill();

        if (load >= 1) {
          if (gifRef.current) gifRef.current.style.display = "none";
          initDissolve();
          phase = "dissolving";
          onDissolveStart?.();
        }
      }

      // ── DISSOLVING ──
      else if (phase === "dissolving") {
        const devW = W * dpr;
        const devH = H * dpr;
        const end  = Math.min(blockCursor + BLOCKS_FRAME, blockOrder.length);

        for (let i = blockCursor; i < end; i++) {
          const idx = blockOrder[i];
          const bx  = (idx % blockCols)           * PX;
          const by  = Math.floor(idx / blockCols) * PX;
          for (let dy = 0; dy < PX; dy++) {
            for (let dx = 0; dx < PX; dx++) {
              const px = bx + dx, py = by + dy;
              if (px >= devW || py >= devH) continue;
              dissolveSnap.data[(py * devW + px) * 4 + 3] = 0;
            }
          }
        }
        blockCursor = end;
        ctx.putImageData(dissolveSnap, 0, 0);
        if (blockCursor >= blockOrder.length) {
          onDone?.();
          return;
        }
      }

      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{ position: "fixed", inset: 0, zIndex: 9999, pointerEvents: "none" }}
      />
      <img
        ref={gifRef}
        src={toothysSquadAnimation}
        alt=""
        style={{
          display: "block",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -55%)",
          width: "min(90vw, 90vh)",
          height: "min(90vw, 90vh)",
          maxWidth: "600px",
          maxHeight: "600px",
          objectFit: "contain",
          zIndex: 10000,
          pointerEvents: "none",
        }}
      />
    </>
  );
};

// ═══════════════════════════════════════════════════════
//  ROOT APP
// ═══════════════════════════════════════════════════════

// All GIFs and WebPs to preload — progress bar reflects their actual load state
const PRELOAD_ASSETS = [
  // Images & WebP
  dinoImage, wizardImage, darkKnightImage, shroomyImage, witchImage, dinoBgPng,marioBgPng,batBgPng,minnieBgPng,frostieBgPng,kittyBgPng,
  flashImage, frostieImage, greenieImage, hulkyImage, kittyImage, 
  marioImage, minnieImage, spideyImage, stormyImage, winnieImage, 
  tootyhzWebp, toothyzPng, journeyMapImage, toothyzProducts, imgFeature1, 
  imgFeature2, imgFeature3, mainBackground, toothyzSquad, 
  shopBackground, toothyzSquad2, aboutBackground,toothyzAnimated,INTRO_GIF,rectangleBlue,rectangleLandscapeLemon,package1,package2,
  rectangleVerticalLightOrange,rectangleVerticalPink,squareCyan,squareGreen,squareLightViolet,squareYellow,

  // Gifs & Animated Icons
  playfulGif, stuffedGif, softGif, shoppingGif, toothysSquadAnimation,
  softIconGif, outdoorIconGif, bathIconGif, paintIconGif, actionIconGif, 
  puzzleIconGif, toothbrushGif, movementGif
];

export default function App() {
  const getPageFromPath = () => {
    const path = window.location.pathname.replace(/^\//, "") || "home";
    const validPages = ["home", "characters", "about", "shop", "game"];
    return validPages.includes(path) ? path : "home";
  };

  const [page, setPage]       = useState(getPageFromPath);
  const [loading, setLoading] = useState(true);
  const [ready, setReady]     = useState(false);
  const [loadProgress, setLoadProgress] = useState(0);
  const dark = true;
  const T = makeTokens(dark);

  const navigate = useCallback((newPage) => {
    setPage(newPage);
    const url = newPage === "home" ? "/" : `/${newPage}`;
    window.history.pushState(null, "", url);
  }, []);

  useEffect(() => {
    const handlePopState = () => setPage(getPageFromPath());
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // Kick off real asset preloading — each load event ticks the progress bar
  useEffect(() => {
    let loaded = 0;
    const total = PRELOAD_ASSETS.length;
    const onAssetSettled = () => {
      loaded += 1;
      setLoadProgress(loaded / total);
    };
    PRELOAD_ASSETS.forEach((src) => {
      const img = new Image();
      img.onload  = onAssetSettled;
      img.onerror = onAssetSettled; // errors still advance the bar
      img.src = src;
    });
  }, []);

  const handleDissolveStart = () => {
    // Make content visible the moment the dissolve starts — canvas sits on top
    setReady(true);
  };

  const handleLoadDone = () => {
    // Canvas dissolve finished — unmount it
    setLoading(false);
  };

  return (
    <ThemeCtx.Provider value={T}>
      {loading && <LoadingScreen onDone={handleLoadDone} onDissolveStart={handleDissolveStart} progress={loadProgress}/>}
      <link href="https://fonts.googleapis.com/css2?family=Bubblegum+Sans&family=Nunito:wght@400;600;700;800;900&display=swap" rel="stylesheet"/>

      <style>{`
        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
        html{scroll-behavior:smooth;}
        body{
          font-family:'Nunito',sans-serif;
          background:${T.bgPage};
          overflow-x:hidden;
          color:${T.textBody};
        }

        @keyframes popup-bounce{
          0%{opacity:0;transform:scale(0.6) translateY(40px);}
          60%{opacity:1;transform:scale(1.08) translateY(-6px);}
          80%{transform:scale(0.97) translateY(2px);}
          100%{opacity:1;transform:scale(1) translateY(0);}
        }
        .popup-bounce{animation:popup-bounce 0.65s cubic-bezier(0.34,1.56,0.64,1) both;}

        @keyframes popup-slide-up{
          0%{opacity:0;transform:translateY(50px) scale(0.94);}
          70%{opacity:1;transform:translateY(-4px) scale(1.01);}
          100%{opacity:1;transform:translateY(0) scale(1);}
        }
        .popup-slide-up{animation:popup-slide-up 0.6s cubic-bezier(0.22,1,0.36,1) both;}

        @keyframes popup-zoom{
          0%{opacity:0;transform:scale(0.5);}
          70%{opacity:1;transform:scale(1.06);}
          100%{opacity:1;transform:scale(1);}
        }
        .popup-zoom{animation:popup-zoom 0.55s cubic-bezier(0.34,1.56,0.64,1) both;}

        @keyframes popup-left{
          0%{opacity:0;transform:translateX(-60px) scale(0.9);}
          70%{opacity:1;transform:translateX(5px) scale(1.01);}
          100%{opacity:1;transform:translateX(0) scale(1);}
        }
        .popup-left{animation:popup-left 0.6s cubic-bezier(0.22,1,0.36,1) both;}

        @keyframes popup-right{
          0%{opacity:0;transform:translateX(60px) scale(0.9);}
          70%{opacity:1;transform:translateX(-5px) scale(1.01);}
          100%{opacity:1;transform:translateX(0) scale(1);}
        }
        .popup-right{animation:popup-right 0.6s cubic-bezier(0.22,1,0.36,1) both;}

        @keyframes emoji-pop{
          0%{opacity:0;transform:scale(0) rotate(-20deg);}
          70%{opacity:1;transform:scale(1.15) rotate(8deg);}
          100%{opacity:1;transform:scale(1) rotate(0deg);}
        }
        .emoji-pop{animation:emoji-pop 0.55s cubic-bezier(0.34,1.56,0.64,1) both;}

        @keyframes neon-pulse{
          0%,100%{box-shadow:0 0 14px rgba(56,189,248,0.15),0 8px 32px rgba(0,0,0,0.5);}
          50%{box-shadow:0 0 28px rgba(56,189,248,0.28),0 0 60px rgba(56,189,248,0.08),0 8px 32px rgba(0,0,0,0.5);}
        }
        .neon-pulse{animation:neon-pulse 3s ease-in-out infinite;}

        @keyframes sparkle-twinkle{
          0%,100%{transform:scale(1) rotate(0deg);opacity:0.7;}
          25%{transform:scale(1.3) rotate(15deg);opacity:1;}
          50%{transform:scale(0.8) rotate(-10deg);opacity:0.4;}
          75%{transform:scale(1.1) rotate(5deg);opacity:0.9;}
        }
        .sparkle-twinkle{animation:sparkle-twinkle ease-in-out infinite;animation-duration:3s;}

        @keyframes sparkle-pulse{
          0%,100%{transform:scale(1);opacity:0.5;}
          50%{transform:scale(1.6);opacity:0.8;}
        }
        .sparkle-pulse{animation:sparkle-pulse ease-in-out infinite;animation-duration:2.5s;}

        @keyframes sparkle-spin-anim{
          0%{transform:rotate(0deg) scale(1);opacity:0.6;}
          33%{transform:rotate(120deg) scale(1.25);opacity:1;}
          66%{transform:rotate(240deg) scale(0.9);opacity:0.5;}
          100%{transform:rotate(360deg) scale(1);opacity:0.6;}
        }
        .sparkle-spin{animation:sparkle-spin-anim ease-in-out infinite;animation-duration:4s;}

        @keyframes heart-beat-anim{
          0%,100%{transform:scale(1);opacity:0.55;}
          15%{transform:scale(1.35);opacity:0.9;}
          30%{transform:scale(1.05);opacity:0.65;}
          45%{transform:scale(1.2);opacity:0.8;}
          60%{transform:scale(1);opacity:0.55;}
        }
        .heart-beat{animation:heart-beat-anim ease-in-out infinite;animation-duration:3.2s;}

        @keyframes tooth-drift-a{
          0%{transform:rotate(-20deg) translateY(0px) translateX(0px);}
          25%{transform:rotate(-5deg) translateY(-18px) translateX(8px);}
          50%{transform:rotate(10deg) translateY(-28px) translateX(-4px);}
          75%{transform:rotate(-2deg) translateY(-14px) translateX(10px);}
          100%{transform:rotate(-20deg) translateY(0px) translateX(0px);}
        }
        .tooth-drift-a{animation:tooth-drift-a ease-in-out infinite;}

        @keyframes tooth-drift-b{
          0%{transform:rotate(15deg) translateY(0px) translateX(0px);}
          30%{transform:rotate(28deg) translateY(-22px) translateX(-10px);}
          60%{transform:rotate(5deg) translateY(-32px) translateX(6px);}
          80%{transform:rotate(20deg) translateY(-10px) translateX(-6px);}
          100%{transform:rotate(15deg) translateY(0px) translateX(0px);}
        }
        .tooth-drift-b{animation:tooth-drift-b ease-in-out infinite;}

        @keyframes tooth-drift-c{
          0%{transform:rotate(-6deg) translateY(0px);}
          20%{transform:rotate(8deg) translateY(-12px) translateX(6px);}
          50%{transform:rotate(-12deg) translateY(-26px) translateX(-8px);}
          70%{transform:rotate(4deg) translateY(-18px) translateX(4px);}
          100%{transform:rotate(-6deg) translateY(0px);}
        }
        .tooth-drift-c{animation:tooth-drift-c ease-in-out infinite;}

        @keyframes tooth-sway{
          0%{transform:rotate(-14deg) translateY(0);}
          100%{transform:rotate(14deg) translateY(-12px);}
        }
        .bg-tooth-drift{animation:tooth-sway ease-in-out infinite alternate;animation-duration:4s;}

        @keyframes hero-float{
          0%,100%{transform:translateY(0) rotate(-1deg);}
          33%{transform:translateY(-16px) rotate(1.5deg);}
          66%{transform:translateY(-8px) rotate(-0.5deg);}
        }
        .hero-float{animation:hero-float 4.5s ease-in-out infinite;}

        @keyframes plush-bob{
          0%,100%{transform:scale(1) rotate(-3deg);}
          25%{transform:scale(1.1) rotate(4deg);}
          50%{transform:scale(1.05) rotate(-1deg);}
          75%{transform:scale(1.08) rotate(3deg);}
        }
        .plush-bob{animation:plush-bob 2.8s ease-in-out infinite;}

        @keyframes product-float{
          0%,100%{transform:translateY(0) rotate(-1deg);}
          50%{transform:translateY(-10px) rotate(1deg);}
        }
        .product-float{animation:product-float 3.2s ease-in-out infinite;}

        @keyframes btn-jelly{
          0%,100%{transform:scale(1);}
          20%{transform:scale(1.08,0.94);}
          40%{transform:scale(0.95,1.06);}
          60%{transform:scale(1.04,0.97);}
          80%{transform:scale(0.98,1.02);}
        }
        .btn-jelly:hover{animation:btn-jelly 0.55s cubic-bezier(0.36,0.07,0.19,0.97) both;}

        @keyframes logo-rock{
          0%,100%{transform:rotate(0deg) scale(1);}
          20%{transform:rotate(-10deg) scale(1.05);}
          40%{transform:rotate(10deg) scale(1.05);}
          60%{transform:rotate(-5deg) scale(1.02);}
          80%{transform:rotate(5deg) scale(1.02);}
        }
        .logo-rock{animation:logo-rock 4s ease-in-out infinite;}

        @keyframes wiggle{
          0%,100%{transform:rotate(0deg);}
          15%{transform:rotate(-12deg);}
          30%{transform:rotate(10deg);}
          45%{transform:rotate(-8deg);}
          60%{transform:rotate(6deg);}
          75%{transform:rotate(-3deg);}
        }
        .wiggle-hover:hover{animation:wiggle 0.7s ease-in-out;}

        @keyframes rubber-pop{
          0%{transform:scale(1);}
          30%{transform:scale(1.25,0.75);}
          50%{transform:scale(0.85,1.15);}
          70%{transform:scale(1.1,0.9);}
          100%{transform:scale(1);}
        }
        .rubber-pop:hover{animation:rubber-pop 0.5s cubic-bezier(0.36,0.07,0.19,0.97);}

        @keyframes spin-slow{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
        .spin-slow{animation:spin-slow 9s linear infinite;}

        @keyframes spin-rev{from{transform:rotate(360deg)}to{transform:rotate(0deg)}}
        .spin-rev{animation:spin-rev 12s linear infinite;}

        @keyframes fade-up{
          from{opacity:0;transform:translateY(28px);}
          to{opacity:1;transform:translateY(0);}
        }
        .fade-up{animation:fade-up 0.7s cubic-bezier(0.22,1,0.36,1) both;}

        @keyframes page-in{
          from{opacity:0;transform:translateY(14px);}
          to{opacity:1;transform:translateY(0);}
        }
        .page-enter{animation:page-in 0.45s cubic-bezier(0.22,1,0.36,1) both;}

        @keyframes char-card-in{
          from{opacity:0;transform:translateY(40px) scale(0.88) rotate(-2deg);}
          to{opacity:1;transform:translateY(0) scale(1) rotate(0deg);}
        }
        .char-card-in{animation:char-card-in 0.6s cubic-bezier(0.34,1.56,0.64,1) both;}

        @keyframes product-card-in{
          from{opacity:0;transform:translateY(30px) scale(0.92);}
          to{opacity:1;transform:translateY(0) scale(1);}
        }
        .product-card-in{animation:product-card-in 0.55s cubic-bezier(0.34,1.56,0.64,1) both;}

        @keyframes shop-pulse{
          0%{box-shadow:0 6px 24px rgba(56,189,248,0.4),0 0 0 0 rgba(56,189,248,0.45);}
          70%{box-shadow:0 6px 24px rgba(56,189,248,0.4),0 0 0 14px rgba(56,189,248,0);}
          100%{box-shadow:0 6px 24px rgba(56,189,248,0.4),0 0 0 0 rgba(56,189,248,0);}
        }
        .shop-pulse{animation:shop-pulse 2.5s ease-in-out infinite;}

        @keyframes shimmer-move{
          0%{background-position:0% center;}
          100%{background-position:200% center;}
        }
        .hero-shimmer{
          background:linear-gradient(90deg,${T.cyan},${T.cyanGlow},#FFFFFF,${T.goldLight},${T.cyan});
          background-size:200% auto;
          -webkit-background-clip:text;
          -webkit-text-fill-color:transparent;
          background-clip:text;
          animation:shimmer-move 4s linear infinite;
        }
        .about-shimmer{
          background:linear-gradient(90deg,${T.cyan},${T.goldLight},${T.cyanGlow},${T.cyan});
          background-size:200% auto;
          -webkit-background-clip:text;
          -webkit-text-fill-color:transparent;
          background-clip:text;
          animation:shimmer-move 3.5s linear infinite;
        }

        @keyframes scroll-line{
          0%,100%{opacity:0.8;transform:scaleY(1);}
          50%{opacity:0.3;transform:scaleY(0.6);}
        }
        @keyframes ci-white-bg-in {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        .scroll-line{
          background:linear-gradient(to bottom,${T.cyanBright},transparent);
          animation:scroll-line 1.8s ease-in-out infinite;
        }

        @keyframes dialog-backdrop-in{
          from{opacity:0;backdrop-filter:blur(0px);}
          to{opacity:1;backdrop-filter:blur(8px);}
        }

        body.dialog-open{overflow:hidden;}
      `}</style>

      <div style={{
        opacity: ready ? 1 : 0,
        transition: "opacity 1s ease 0.2s",
      }}>
        <Sparkles/>
      </div>

      <div className="fixed inset-0 pointer-events-none" style={{zIndex:0}}>
        <div style={{position:"absolute",top:0,left:0,width:500,height:500,
          background:`radial-gradient(circle at top left, ${T.cyanBright}06 0%, transparent 70%)`}}/>
        <div style={{position:"absolute",bottom:0,right:0,width:500,height:500,
          background:`radial-gradient(circle at bottom right, ${T.gold}05 0%, transparent 70%)`}}/>
        <div style={{position:"absolute",top:"40%",right:0,width:300,height:300,
          background:`radial-gradient(circle at right, ${T.pink}04 0%, transparent 70%)`}}/>
      </div>

      <div style={{ visibility: loading ? "hidden" : "visible" }}>
        <Navbar page={page} setPage={navigate}/>
      </div>

      <main key={page} style={{
        opacity: ready ? 1 : 0,
        transform: ready ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 0.7s cubic-bezier(0.22,1,0.36,1), transform 0.7s cubic-bezier(0.22,1,0.36,1)",
      }}>
        {page==="home"       && <HomePage       setPage={navigate} showMascot={!loading}/>}
        {page==="characters" && <EngulfWrapper><PlushiesPage setPage={navigate}/></EngulfWrapper>}
        {page==="about"      && <AboutPage      setPage={navigate}/>}
        {page==="shop"       && <ShopPage       setPage={navigate} isLoading={loading}/>}
        {page==="game"       && <FlappyBird setPage={navigate}/>}
      </main>
    </ThemeCtx.Provider>
  );
}